(function () {
  var wizard = document.getElementById("bajka-wizard");
  if (!wizard) return;
  var bajkaStep1IntroEl = wizard.querySelector("[data-bajka-character-intro]");
  var bajkaStep1IntroHtml = bajkaStep1IntroEl
    ? bajkaStep1IntroEl.innerHTML
    : "";

  var themeTitleEl = wizard.querySelector("[data-bajka-theme-title]");
  var bajkaDefaultBookImage = ""; // default product image (independent of the variant)
  var bajkaCurrentHandle = ""; // handle of the currently configured book (for cross-sell exclusion)
  var bajkaCurrentTheme = ""; // Thema (Metafeld custom.mapping) -> Line-Item-Property _theme
  var bajkaHeldFallbackImage = ""; // When editing: saved preview image used as the hero image
  var bajkaPreservedPhotoUrl = ""; // S3 key from cart edit when the file input cannot be prefilled
  var bajkaPreservedPhotoName = ""; // Display filename for Zdjęcie when re-saving without a new upload
  var bajkaCharacterConfig = null;
  var bajkaCharacters = [];
  var bajkaCharacterIndex = 0;
  var bajkaCharacterConfigInvalid = false;

  var bajkaWizardConfig = JSON.parse(
    document.getElementById("bajka-wizard-config").textContent,
  );
  var BAJKA_BOOK_LANGUAGE = bajkaWizardConfig.bookLanguage;

  function bajkaNormalizeBookLanguage(locale) {
    var code = String(locale || BAJKA_BOOK_LANGUAGE || "pl")
      .trim()
      .toLowerCase()
      .slice(0, 2);
    return code === "en" ? "en" : "pl";
  }

  function bajkaSelectedBookLanguage() {
    var selected = wizard.querySelector(
      '[data-field="book-language"] .bajka-option.is-selected[data-bajka-book-language]',
    );
    return bajkaNormalizeBookLanguage(
      selected && selected.getAttribute("data-value"),
    );
  }

  function bajkaSetBookLanguage(locale) {
    var code = bajkaNormalizeBookLanguage(locale);
    wizard
      .querySelectorAll("[data-bajka-book-language]")
      .forEach(function (btn) {
        var selected = btn.getAttribute("data-value") === code;
        btn.classList.toggle("is-selected", selected);
        btn.setAttribute("aria-pressed", selected ? "true" : "false");
      });
  }

  var BAJKA_SHOP_DOMAIN = bajkaWizardConfig.shopDomain;
  var BAJKA_I18N = bajkaWizardConfig.i18n;
  function bajkaOptionLabel(value) {
    return (BAJKA_I18N.optionLabels && BAJKA_I18N.optionLabels[value]) || value;
  }
  function bajkaFormatAge(n) {
    if (n === 1) return BAJKA_I18N.ageOne;
    if (BAJKA_BOOK_LANGUAGE === "pl" && n >= 2 && n <= 4) {
      return BAJKA_I18N.ageFew.replace("__N__", String(n));
    }
    return BAJKA_I18N.ageOther.replace("__N__", String(n));
  }

  var BAJKA_CHECKOUT_LABEL_ADD = BAJKA_I18N.checkoutAdd;
  var BAJKA_CHECKOUT_LABEL_UPDATE = BAJKA_I18N.checkoutUpdate;
  var BAJKA_ADD_SAME_DEDICATION_LABEL =
    bajkaWizardConfig.addSameDedicationLabel;
  var BAJKA_ADD_SAME_FINAL_PHOTO_LABEL =
    bajkaWizardConfig.addSameFinalPhotoLabel;
  var BAJKA_UPSELL_NOTICE_TEXT = bajkaWizardConfig.upsellNoticeText;
  var BAJKA_UPSELL_NOTICE_KEY = "bajka_upsell_without_personalization_notice";
  // True when opened from cart via [data-bajka-edit-open] (cart line "Edytuj").
  var bajkaIsCartEditMode = false;

  function setCheckoutLabel(text) {
    var lbl = wizard.querySelector("[data-bajka-checkout-label]");
    if (lbl) lbl.textContent = text;
  }

  function syncCheckoutLabel() {
    setCheckoutLabel(
      bajkaIsCartEditMode
        ? BAJKA_CHECKOUT_LABEL_UPDATE
        : BAJKA_CHECKOUT_LABEL_ADD,
    );
  }

  function bajkaLegacyCharacterConfig() {
    return {
      version: 1,
      slots: [{ key: "child_1", role: "child", required: true }],
      preview: null,
    };
  }

  function bajkaNormalizeCharacterConfig(rawValue) {
    if (!rawValue) return bajkaLegacyCharacterConfig();
    var parsed = typeof rawValue === "string" ? JSON.parse(rawValue) : rawValue;
    if (!parsed || parsed.version !== 1 || !Array.isArray(parsed.slots)) {
      throw new Error("Unsupported character configuration");
    }
    if (parsed.slots.length < 1 || parsed.slots.length > 3) {
      throw new Error("Character configuration must contain 1-3 slots");
    }
    var keys = {};
    parsed.slots = parsed.slots.map(function (slot) {
      var key = slot && typeof slot.key === "string" ? slot.key.trim() : "";
      if (!key || keys[key])
        throw new Error("Character slot keys must be unique");
      keys[key] = true;
      return {
        key: key,
        role: slot.role === "guardian" ? "guardian" : "child",
        required: slot.required !== false,
      };
    });
    if (parsed.slots.length > 1) {
      var preview = parsed.preview && parsed.preview.default;
      if (
        !preview ||
        !preview.illustrationId ||
        !Array.isArray(preview.characters)
      ) {
        throw new Error("Multi-character preview configuration is incomplete");
      }
      var previewKeys = {};
      preview.characters.forEach(function (character) {
        if (
          !character ||
          !keys[character.slotKey] ||
          !character.characterId ||
          previewKeys[character.slotKey]
        ) {
          throw new Error("Multi-character preview mapping is invalid");
        }
        previewKeys[character.slotKey] = true;
      });
      parsed.slots.forEach(function (slot) {
        if (slot.required && !previewKeys[slot.key]) {
          throw new Error("A required character has no preview mapping");
        }
      });
    }
    return parsed;
  }

  function bajkaSetCharacterConfig(rawValue) {
    bajkaCharacterConfigInvalid = false;
    try {
      bajkaCharacterConfig = bajkaNormalizeCharacterConfig(rawValue);
    } catch (error) {
      bajkaCharacterConfigInvalid = true;
      bajkaCharacterConfig = { version: 1, slots: [], preview: null };
      if (window.console)
        console.warn("[bajka] Invalid character configuration:", error);
    }
  }

  function bajkaCreateCharacterState(slot) {
    return {
      slotKey: slot.key,
      role: slot.role,
      required: slot.required,
      name: "",
      gender: "",
      age: "",
      hair: "",
      eyes: "",
      file: null,
      photoUrl: "",
      photoName: "",
      uploadedKey: null,
      uploadedFor: null,
      consent: false,
    };
  }

  function bajkaIsMultiCharacter() {
    return !!(bajkaCharacterConfig && bajkaCharacterConfig.slots.length > 1);
  }

  function bajkaCaptureCurrentCharacter() {
    var character = bajkaCharacters[bajkaCharacterIndex];
    if (!character) return;
    var panel = wizard.querySelector('[data-step-panel="1"]');
    var name = panel && panel.querySelector("#bajka-name");
    var age = panel && panel.querySelector("#bajka-age");
    var photo = panel && panel.querySelector("#bajka-photo");
    var consent = panel && panel.querySelector("#bajka-consent");
    character.name = (name && name.value.trim()) || "";
    character.age = (age && age.value.trim()) || "";
    character.gender = bajkaSelectedOption("gender");
    character.hair = bajkaSelectedOption("hair");
    character.eyes = bajkaSelectedOption("eyes");
    var inputFile = photo && photo.files && photo.files[0];
    if (bajkaIsMultiCharacter() && inputFile && !character.file)
      inputFile = null;
    character.file = inputFile || character.file || null;
    character.photoUrl = bajkaPreservedPhotoUrl || "";
    character.photoName =
      bajkaPreservedPhotoName || (character.file && character.file.name) || "";
    character.uploadedKey = bajkaUploadedKey;
    character.uploadedFor = bajkaUploadedFor;
    character.consent = !!(consent && consent.checked);
  }

  function bajkaCharacterHasPhoto(character) {
    return !!(
      character &&
      (character.file || character.photoUrl || character.uploadedKey)
    );
  }

  function bajkaCharacterIsValid(character) {
    if (!character || !character.required) return true;
    return !!(
      character.name &&
      character.gender &&
      character.age &&
      character.hair &&
      character.eyes &&
      bajkaCharacterHasPhoto(character) &&
      character.consent
    );
  }

  function bajkaLoadCharacter(index) {
    var character = bajkaCharacters[index];
    var panel = wizard.querySelector('[data-step-panel="1"]');
    if (!character || !panel) return;
    bajkaCharacterIndex = index;
    var name = panel.querySelector("#bajka-name");
    var age = panel.querySelector("#bajka-age");
    var photo = panel.querySelector("#bajka-photo");
    var consent = panel.querySelector("#bajka-consent");
    if (name) name.value = character.name || "";
    if (age) age.value = character.age || "";
    ["gender", "hair", "eyes"].forEach(function (field) {
      panel
        .querySelectorAll('[data-field="' + field + '"] .bajka-option')
        .forEach(function (option) {
          option.classList.toggle(
            "is-selected",
            option.getAttribute("data-value") === character[field],
          );
        });
    });
    if (photo) {
      photo.value = "";
      if (character.file && typeof DataTransfer !== "undefined") {
        try {
          var transfer = new DataTransfer();
          transfer.items.add(character.file);
          photo.files = transfer.files;
        } catch (error) {}
      }
    }
    if (consent) consent.checked = !!character.consent;
    bajkaPreservedPhotoUrl = character.photoUrl || "";
    bajkaPreservedPhotoName = character.photoName || "";
    bajkaUploadedKey = character.uploadedKey || null;
    bajkaUploadedFor = character.uploadedFor || null;
    panel
      .querySelectorAll(
        '.bajka-field-pair, [data-field="hair"], [data-field="eyes"], [data-field="photo"]',
      )
      .forEach(function (field) {
        field.hidden = !character.name;
      });
    updateHairTierPreviews();
    restoreStep1PhotoPreview();
    bajkaUpdateCharacterProgress();
    checkStep1();
    if (name) name.focus();
  }

  function bajkaUpdateCharacterProgress() {
    var progress = wizard.querySelector("[data-bajka-character-progress]");
    var label = wizard.querySelector(
      "[data-bajka-preview-create] .bajka-cta-gold",
    );
    var back = wizard.querySelector("[data-bajka-character-back]");
    var total = bajkaCharacters.length || 1;
    if (progress) {
      progress.hidden = total <= 1;
      progress.textContent = BAJKA_I18N.characterProgress
        .replace("__N__", String(bajkaCharacterIndex + 1))
        .replace("__TOTAL__", String(total));
    }
    if (label) {
      label.textContent =
        bajkaCharacterIndex < total - 1
          ? BAJKA_I18N.nextCharacter
          : BAJKA_I18N.createPreview;
    }
    if (back) back.hidden = total <= 1 || bajkaCharacterIndex === 0;
  }

  function openWizard(trigger) {
    syncCheckoutLabel();
    if (trigger && themeTitleEl) {
      var title = trigger.getAttribute("data-product-title");
      if (title) themeTitleEl.textContent = title;
    }
    if (trigger && trigger.getAttribute) {
      var pimg = trigger.getAttribute("data-product-image");
      if (pimg) bajkaDefaultBookImage = pimg;
      var phandle = trigger.getAttribute("data-product-handle");
      if (phandle) bajkaCurrentHandle = phandle;
      var ptheme = trigger.getAttribute("data-product-theme");
      if (ptheme) bajkaCurrentTheme = ptheme;
      bajkaSetCharacterConfig(
        trigger.getAttribute("data-bajka-character-config") || "",
      );
      bajkaHeldFallbackImage = ""; // fresh flow: no edit fallback
      bajkaPreservedPhotoUrl = "";
      bajkaPreservedPhotoName = "";
    } else if (!bajkaCharacterConfig) {
      bajkaSetCharacterConfig("");
    }
    // Insert product cards (step 3) from the product template
    var productsTarget = wizard.querySelector("[data-bajka-products]");
    var templateId =
      trigger && trigger.getAttribute
        ? trigger.getAttribute("data-bajka-products-template")
        : "";
    var tpl = templateId ? document.getElementById(templateId) : null;
    if (!tpl) tpl = document.getElementById("bajka-step3-products");
    if (productsTarget && tpl) {
      productsTarget.innerHTML = tpl.innerHTML;
    }
    // Reset format selection -> "Next" in step 3 only active after selection
    var step3Next = wizard.querySelector('[data-bajka-next="4"]');
    if (step3Next) step3Next.disabled = true;
    // Insert upsell cards (step 4)
    var extrasTarget = wizard.querySelector("[data-bajka-extras]");
    var extrasTpl = document.getElementById("bajka-step4-extras");
    if (extrasTarget && extrasTpl) {
      extrasTarget.innerHTML = extrasTpl.innerHTML;
      updateDedicationDefaults();
    }
    // Cross-sell cards are inserted only when the popup opens (depending on gender)
    refreshCartBajkaCounts().catch(function () {});
    wizard.classList.add("is-open");
    wizard.setAttribute("aria-hidden", "false");
    document.body.classList.add("bajka-wizard-open");
    if (bajkaStep1IntroEl) {
      if (bajkaCharacterConfigInvalid) {
        bajkaStep1IntroEl.textContent = BAJKA_I18N.configurationInvalid;
      } else {
        bajkaStep1IntroEl.innerHTML = bajkaStep1IntroHtml;
      }
    }
  }

  // When editing: keys of the old cart group to be replaced
  var editingOldGroupKeys = [];

  function closeWizard() {
    wizard.classList.remove("is-open");
    wizard.setAttribute("aria-hidden", "true");
    document.body.classList.remove("bajka-wizard-open");
    // Editing cancelled -> do NOT replace the old group
    editingOldGroupKeys = [];
    bajkaIsCartEditMode = false;
    clearFamilyPhotoUploadError();
    resetAddToCartState();
  }

  // Reset the wizard for a FRESH personalisation (step 1, empty fields)
  function resetWizard() {
    var s1 = wizard.querySelector('[data-step-panel="1"]');
    if (s1) {
      var nameInput = s1.querySelector("#bajka-name");
      if (nameInput) nameInput.value = "";
      var ageInput = s1.querySelector("#bajka-age");
      if (ageInput) ageInput.value = "";
      // Clear selection (gender/hair/eyes)
      s1.querySelectorAll(".bajka-option.is-selected").forEach(function (b) {
        b.classList.remove("is-selected");
      });
      updateHairTierPreviews();
      // Hide progressive fields again (gender+age as a pair)
      s1.querySelectorAll(
        '.bajka-field-pair, [data-field="hair"], [data-field="eyes"], [data-field="photo"]',
      ).forEach(function (f) {
        f.hidden = true;
      });
      // Reset photo + preview
      var photoInput = s1.querySelector("#bajka-photo");
      if (photoInput) photoInput.value = "";
      var preview = s1.querySelector("[data-bajka-preview]");
      if (preview) {
        preview.hidden = true;
        preview.removeAttribute("src");
      }
      var placeholder = s1.querySelector("[data-bajka-placeholder]");
      if (placeholder) placeholder.hidden = false;
      var filename = s1.querySelector("[data-bajka-filename]");
      if (filename) {
        filename.hidden = true;
        filename.textContent = "";
      }
      var consent = s1.querySelector("#bajka-consent");
      if (consent) consent.checked = false;
      // Lock "Create preview" again
      var previewBtn = s1.querySelector("[data-bajka-preview-create]");
      if (previewBtn) previewBtn.disabled = true;
    }
    window.BajkaWizardPreview.reset();
    bajkaUploadedKey = null;
    bajkaUploadedFor = null;
    if (bajkaStep1PhotoObjectUrl) {
      try {
        URL.revokeObjectURL(bajkaStep1PhotoObjectUrl);
      } catch (e) {}
      bajkaStep1PhotoObjectUrl = "";
    }
    // Not in edit mode -> do not replace the old group
    editingOldGroupKeys = [];
    bajkaIsCartEditMode = false;
    bajkaSetBookLanguage(BAJKA_BOOK_LANGUAGE);
    bajkaPreservedPhotoUrl = "";
    bajkaPreservedPhotoName = "";
    bajkaCharacters = (
      bajkaCharacterConfig && bajkaCharacterConfig.slots.length
        ? bajkaCharacterConfig.slots
        : []
    ).map(bajkaCreateCharacterState);
    bajkaCharacterIndex = 0;
    syncCheckoutLabel();
    if (bajkaCharacters.length) bajkaLoadCharacter(0);
    else bajkaUpdateCharacterProgress();
    updatePreviewName();
    goToStep(1);
  }

  document.addEventListener(
    "click",
    function (e) {
      var opener = e.target.closest("[data-bajka-wizard-open]");
      if (!opener) {
        var wizardLink = e.target.closest('a[href="#bajka-wizard-button"]');
        if (wizardLink)
          opener = document.querySelector("[data-bajka-wizard-open]");
      }
      if (opener) {
        e.preventDefault();
        bajkaIsCartEditMode = false;
        openWizard(opener);
        resetWizard();
      } else if (e.target.closest("[data-bajka-wizard-close]")) {
        e.preventDefault();
        closeWizard();
      }
    },
    true,
  );

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && wizard.classList.contains("is-open")) {
      closeWizard();
    }
  });

  /* --- Step 1: progressive field reveal + validation --- */
  var step1 = wizard.querySelector('[data-step-panel="1"]');
  if (step1) {
    // Reveal next field + smoothly scroll to it
    function revealNext(field) {
      var next = field.nextElementSibling;
      while (
        next &&
        !(
          next.classList.contains("bajka-field") ||
          next.classList.contains("bajka-field-pair")
        )
      ) {
        next = next.nextElementSibling;
      }
      if (next) {
        var wasHidden = next.hidden;
        next.hidden = false;
        if (wasHidden && next.scrollIntoView) {
          // wait briefly until the field is visible, then smoothly scroll to it
          setTimeout(function () {
            next.scrollIntoView({ behavior: "smooth", block: "center" });
          }, 80);
        }
      }
    }

    // Checks whether ALL required fields + consent are filled -> activate button
    // checkStep1() is defined above (shared with edit/back navigation)

    // Name input -> reveal gender
    var nameInput = step1.querySelector("#bajka-name");
    if (nameInput) {
      nameInput.addEventListener("input", function () {
        if (nameInput.value.trim() !== "") {
          revealNext(nameInput.closest(".bajka-field"));
        }
        bajkaInvalidatePreviewCache();
        checkStep1();
      });
    }

    // Age input -> reveal next field + check button state
    var ageInput = step1.querySelector("#bajka-age");
    if (ageInput) {
      ageInput.addEventListener("input", function () {
        if (ageInput.value.trim() !== "") {
          revealNext(
            ageInput.closest(".bajka-field-pair") ||
              ageInput.closest(".bajka-field"),
          );
        }
        bajkaInvalidatePreviewCache();
        checkStep1();
      });
    }

    // Option buttons -> mark selected + reveal next field
    step1.querySelectorAll(".bajka-option").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var group = btn.closest(".bajka-options");
        group.querySelectorAll(".bajka-option").forEach(function (b) {
          b.classList.remove("is-selected");
        });
        btn.classList.add("is-selected");
        if (btn.closest('[data-field="gender"]')) {
          updateHairTierPreviews();
        }
        bajkaInvalidatePreviewCache();
        // Gender does not trigger scroll (age is beside it); scroll happens after age is entered
        if (!btn.closest('[data-field="gender"]')) {
          revealNext(btn.closest(".bajka-field"));
        }
        checkStep1();
      });
    });

    // Book language (step 4) — pl/en for cart _language
    wizard
      .querySelectorAll("[data-bajka-book-language]")
      .forEach(function (btn) {
        btn.addEventListener("click", function () {
          bajkaSetBookLanguage(btn.getAttribute("data-value"));
        });
      });

    // Photo upload -> show preview + filename
    var photoInput = step1.querySelector("#bajka-photo");
    if (photoInput) {
      photoInput.addEventListener("change", function () {
        var file = photoInput.files && photoInput.files[0];
        var character = bajkaCharacters[bajkaCharacterIndex];
        bajkaInvalidatePreviewCache();
        bajkaPreservedPhotoUrl = "";
        bajkaPreservedPhotoName = file ? file.name : "";
        bajkaUploadedKey = null;
        bajkaUploadedFor = null;
        if (character) {
          character.file = file || null;
          character.photoUrl = "";
          character.photoName = file ? file.name : "";
          character.uploadedKey = null;
          character.uploadedFor = null;
          character.originalKey = null;
          character.originalFor = null;
          character.originalPromise = null;
          if (file) {
            bajkaEnsureOriginalUpload(character).catch(function () {});
          }
        }
        restoreStep1PhotoPreview();
        checkStep1();
      });
    }

    // Consent checkbox -> check button state
    var consentInput = step1.querySelector("#bajka-consent");
    if (consentInput) {
      consentInput.addEventListener("change", checkStep1);
    }

    // Initialzustand setzen
    checkStep1();
  }

  // Preview for upload boxes in extras (e.g. family photo for the certificate)
  wizard.addEventListener("change", function (e) {
    var input = e.target.closest(".bajka-upload__input[data-prop]");
    if (!input) return;
    if (input.getAttribute("data-prop") === "Zdjęcie rodzinne") {
      var photoCard = input.closest(".bajka-product");
      if (photoCard)
        photoCard.removeAttribute("data-bajka-uploaded-final-photo");
      clearFamilyPhotoUploadError();
    }
    var box = input.closest(".bajka-upload");
    if (!box) return;
    var preview = box.querySelector(".bajka-upload__preview");
    var placeholder = box.querySelector(".bajka-upload__placeholder");
    var file = input.files && input.files[0];
    if (file && preview) {
      var reader = new FileReader();
      reader.onload = function (ev) {
        preview.src = ev.target.result;
        preview.hidden = false;
        if (placeholder) placeholder.hidden = true;
      };
      reader.readAsDataURL(file);
    } else if (preview) {
      preview.hidden = true;
      if (placeholder) placeholder.hidden = false;
    }
  });

  // Input in extra fields -> re-check "Next" (step 4)
  function onExtraFieldChange(e) {
    if (e.target.closest("[data-bajka-extras] [data-prop]")) checkStep4();
  }
  wizard.addEventListener("input", onExtraFieldChange);
  wizard.addEventListener("change", onExtraFieldChange);

  /* --- Step change + progress bar --- */
  var panels = wizard.querySelectorAll("[data-step-panel]");
  var progressSteps = wizard.querySelectorAll(".bajka-wizard__step");
  var content = wizard.querySelector(".bajka-wizard__content");
  var currentStep = 1;

  function bajkaSelectedOption(field) {
    var el = wizard.querySelector(
      '[data-field="' + field + '"] .bajka-option.is-selected',
    );
    return el ? el.getAttribute("data-value") : "";
  }

  function bajkaAgeValue() {
    var el = wizard.querySelector("#bajka-age");
    return el && el.value.trim() !== "" ? el.value.trim() : "";
  }

  function bajkaHasPhoto() {
    var character = bajkaCharacters[bajkaCharacterIndex];
    if (bajkaIsMultiCharacter()) {
      return !!(
        (character &&
          (character.file || character.photoUrl || character.uploadedKey)) ||
        bajkaPreservedPhotoUrl ||
        bajkaUploadedKey
      );
    }
    var photoEl = wizard.querySelector("#bajka-photo");
    if (photoEl && photoEl.files && photoEl.files.length > 0) return true;
    return !!(bajkaPreservedPhotoUrl || bajkaUploadedKey);
  }

  // Step 2 preview (generation, cache, email nudge) lives in bajka-wizard-preview.js.
  function bajkaInvalidatePreviewCache() {
    window.BajkaWizardPreview.invalidateCache();
  }

  function bajkaHasCachedPreview() {
    return window.BajkaWizardPreview.hasCached();
  }

  function bajkaTryRestoreCachedPreview() {
    window.BajkaWizardPreview.tryRestoreCached();
  }

  function bajkaGeneratePreview() {
    window.BajkaWizardPreview.generate();
  }

  function restoreStep1PhotoPreview() {
    var step1Panel = wizard.querySelector('[data-step-panel="1"]');
    if (!step1Panel) return;
    var photoInput = step1Panel.querySelector("#bajka-photo");
    var preview = step1Panel.querySelector("[data-bajka-preview]");
    var placeholder = step1Panel.querySelector("[data-bajka-placeholder]");
    var nameEl = step1Panel.querySelector("[data-bajka-filename]");
    var character = bajkaCharacters[bajkaCharacterIndex];
    var inputFile = photoInput && photoInput.files && photoInput.files[0];
    // The step is one shared file input. After switching characters it can
    // still hold the previous child's photo, so a multi-character step only
    // previews the file stored on the active character.
    var file =
      (character && character.file) ||
      (!bajkaIsMultiCharacter() && inputFile) ||
      null;

    if (bajkaStep1PhotoObjectUrl) {
      try {
        URL.revokeObjectURL(bajkaStep1PhotoObjectUrl);
      } catch (e) {}
      bajkaStep1PhotoObjectUrl = "";
    }

    function showPhotoPreview(src, label) {
      if (preview) {
        preview.src = src;
        preview.hidden = false;
      }
      if (placeholder) placeholder.hidden = true;
      if (nameEl) {
        nameEl.textContent = label;
        nameEl.hidden = false;
      }
    }

    if (file) {
      bajkaStep1PhotoObjectUrl = URL.createObjectURL(file);
      showPhotoPreview(bajkaStep1PhotoObjectUrl, file.name);
      return;
    }

    var src =
      bajkaIsMultiCharacter() && character
        ? resolvePhotoSrc(character.photoUrl) ||
          resolvePhotoSrc(character.uploadedKey)
        : resolvePhotoSrc(bajkaPreservedPhotoUrl) ||
          resolvePhotoSrc(bajkaUploadedKey);
    if (src) {
      showPhotoPreview(
        src,
        (character && character.photoName) ||
          bajkaPreservedPhotoName ||
          BAJKA_I18N.photo,
      );
      return;
    }

    if (preview) {
      preview.hidden = true;
      preview.removeAttribute("src");
    }
    if (placeholder) placeholder.hidden = false;
    if (nameEl) {
      nameEl.hidden = true;
      nameEl.textContent = "";
    }
  }

  function checkStep1() {
    var step1Panel = wizard.querySelector('[data-step-panel="1"]');
    if (!step1Panel) return;
    var cta = step1Panel.querySelector("[data-bajka-preview-create]");
    if (!cta) return;
    var nameInput = step1Panel.querySelector("#bajka-name");
    var nameOk = nameInput && nameInput.value.trim() !== "";
    var genderOk = !!step1Panel.querySelector(
      '[data-field="gender"] .bajka-option.is-selected',
    );
    var ageEl = step1Panel.querySelector("#bajka-age");
    var ageOk = ageEl && ageEl.value.trim() !== "";
    var hairOk = !!step1Panel.querySelector(
      '[data-field="hair"] .bajka-option.is-selected',
    );
    var eyesOk = !!step1Panel.querySelector(
      '[data-field="eyes"] .bajka-option.is-selected',
    );
    var photoOk = bajkaHasPhoto();
    var consentEl = step1Panel.querySelector("#bajka-consent");
    var consentOk = consentEl && consentEl.checked;
    cta.disabled =
      bajkaCharacterConfigInvalid ||
      !(
        nameOk &&
        genderOk &&
        ageOk &&
        hairOk &&
        eyesOk &&
        photoOk &&
        consentOk
      );
    bajkaUpdateCharacterProgress();
  }

  // The final cart action can be reached after editing or restoring a
  // previous configuration, so the disabled preview button is not enough
  // protection. Re-check every required character field at the last point
  // before building the cart payload.
  function validateStep1BeforeCart() {
    var step1Panel = wizard.querySelector('[data-step-panel="1"]');
    if (!step1Panel) return true;

    var nameInput = step1Panel.querySelector("#bajka-name");
    var ageInput = step1Panel.querySelector("#bajka-age");
    var missing = [];
    if (!nameInput || nameInput.value.trim() === "")
      missing.push(BAJKA_I18N.missingName);
    if (
      !step1Panel.querySelector(
        '[data-field="gender"] .bajka-option.is-selected',
      )
    )
      missing.push(BAJKA_I18N.missingGender);
    if (!ageInput || ageInput.value.trim() === "")
      missing.push(BAJKA_I18N.missingAge);
    if (
      !step1Panel.querySelector('[data-field="hair"] .bajka-option.is-selected')
    )
      missing.push(BAJKA_I18N.missingHair);
    if (
      !step1Panel.querySelector('[data-field="eyes"] .bajka-option.is-selected')
    )
      missing.push(BAJKA_I18N.missingEyes);
    if (!bajkaHasPhoto()) missing.push(BAJKA_I18N.missingPhoto);
    var consentInput = step1Panel.querySelector("#bajka-consent");
    if (!consentInput || !consentInput.checked)
      missing.push(BAJKA_I18N.missingConsent);

    if (bajkaIsMultiCharacter()) {
      bajkaCaptureCurrentCharacter();
      var invalidIndex = -1;
      bajkaCharacters.some(function (character, index) {
        if (!bajkaCharacterIsValid(character)) {
          invalidIndex = index;
          return true;
        }
        return false;
      });
      if (invalidIndex !== -1) {
        bajkaLoadCharacter(invalidIndex);
        checkStep1();
        goToStep(1);
        window.alert(
          BAJKA_I18N.fillRequired.replace(
            "%{fields}",
            BAJKA_I18N.characterProgress
              .replace("__N__", String(invalidIndex + 1))
              .replace("__TOTAL__", String(bajkaCharacters.length)),
          ),
        );
        return false;
      }
      return true;
    }

    if (!missing.length) return true;

    checkStep1();
    goToStep(1);
    window.alert(
      BAJKA_I18N.fillRequired.replace("%{fields}", missing.join(", ")),
    );
    return false;
  }

  function goToStep(n) {
    n = Number(n);
    currentStep = n;
    panels.forEach(function (p) {
      p.hidden = Number(p.getAttribute("data-step-panel")) !== n;
    });
    // Panel -> progress node: extras (panel 4) holds "book" (3), summary (panel 5) = "order" (4)
    var panelToProgress = { 1: 1, 2: 2, 3: 3, 4: 3, 5: 4 };
    var progressN = panelToProgress[n] || n;
    progressSteps.forEach(function (s) {
      var sn = Number(s.getAttribute("data-step"));
      s.classList.toggle("is-active", sn === progressN);
      s.classList.toggle("is-done", sn < progressN);
    });
    if (n === 1) {
      restoreStep1PhotoPreview();
      checkStep1();
    }
    if (n === 2) {
      updatePreviewName();
      bajkaTryRestoreCachedPreview();
    }
    if (n === 4) {
      updateDedicationDefaults();
      checkStep4();
    }
    if (n === 5) buildSummary();
    if (content) content.scrollTop = 0;
  }

  function getStep4Validation() {
    var firstMissing = null;
    var valid = true;
    wizard
      .querySelectorAll("[data-bajka-extras] .bajka-product.is-selected")
      .forEach(function (card) {
        card.querySelectorAll("[data-prop]").forEach(function (inp) {
          var missing = false;
          if (inp.type === "file") {
            missing =
              !(inp.files && inp.files.length > 0) &&
              !card.getAttribute("data-bajka-preserved-final-photo");
          } else if (
            !inp.hasAttribute("data-optional") &&
            (!inp.value || inp.value.trim() === "")
          ) {
            missing = true;
          }
          if (missing) {
            valid = false;
            if (!firstMissing) {
              firstMissing =
                inp.closest(".bajka-extra-field") ||
                inp.closest(".bajka-upload") ||
                inp;
            }
          }
        });
      });
    return { valid: valid, firstMissing: firstMissing };
  }

  function highlightMissingExtraField(el) {
    if (!el) return;
    if (el.scrollIntoView) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    el.classList.remove("bajka-field-error");
    void el.offsetWidth;
    el.classList.add("bajka-field-error");
    el.addEventListener(
      "animationend",
      function () {
        el.classList.remove("bajka-field-error");
      },
      { once: true },
    );
    var focusable = el.querySelector(
      'input:not([type="file"]), textarea, select',
    );
    if (focusable && focusable.focus) {
      setTimeout(function () {
        focusable.focus();
      }, 400);
    }
  }

  // Step 4: track whether selected extras have all required fields filled
  function checkStep4() {
    return getStep4Validation();
  }

  // Fill the preview title with the name entered in step 1
  function updatePreviewName() {
    var target = wizard.querySelector("[data-bajka-preview-name]");
    if (!target) return;
    if (bajkaIsMultiCharacter()) {
      bajkaCaptureCurrentCharacter();
      var names = bajkaCharacters
        .map(function (character) {
          return character.name;
        })
        .filter(Boolean);
      target.textContent = names.length
        ? names.join(" i ")
        : BAJKA_I18N.yourHeroPossessive;
      return;
    }
    var nameInput = wizard.querySelector("#bajka-name");
    var name = nameInput ? nameInput.value.trim() : "";
    target.textContent = name !== "" ? name : BAJKA_I18N.yourHeroPossessive;
  }

  // "Back" buttons (per step) -> go one step back
  wizard.addEventListener("click", function (e) {
    if (e.target.closest("[data-bajka-character-back]")) {
      e.preventDefault();
      if (bajkaCharacterIndex > 0) {
        bajkaCaptureCurrentCharacter();
        bajkaLoadCharacter(bajkaCharacterIndex - 1);
      }
      return;
    }
    if (e.target.closest("[data-bajka-back]")) {
      e.preventDefault();
      if (currentStep > 1) goToStep(currentStep - 1);
    }
  });

  var EYE_COLOR_MAP = {
    Brąz: "brown",
    Niebieski: "blue",
    Piwny: "hazel",
    Zielony: "green",
    Szary: "gray",
    Szaroniebieski: "gray-blue",
    Orzechowy: "hazel",
    Turkusowy: "turquoise",
  };
  var HAIR_LENGTH_MAP = {
    krótkie: "short",
    średnie: "medium",
    długie: "long",
    "bardzo długie": "very_long",
  };
  var GENDER_MAP = {
    Chłopiec: "male",
    Dziewczyna: "female",
    Dziewczynka: "female",
  };
  var DEDICATION_DEFAULTS = {
    boy: {
      placeholder: BAJKA_I18N.dedicationPlaceholder,
      message: BAJKA_I18N.dedicationMessageBoy,
    },
    girl: {
      placeholder: BAJKA_I18N.dedicationPlaceholder,
      message: BAJKA_I18N.dedicationMessageGirl,
    },
  };
  var DEDICATION_DEFAULT_MESSAGES = Object.keys(DEDICATION_DEFAULTS).map(
    function (key) {
      return DEDICATION_DEFAULTS[key].message;
    },
  );
  var UPLOAD_ENDPOINT = "https://www.childbook.ai/api/upload-child-photo";
  var PREVIEW_RESUME_ENDPOINT =
    "https://book-api-production-298d.up.railway.app/api/v4-preview/resume/";
  var BAJKA_RESUME_PARAM = "bajka_resume";
  var bajkaUploadedKey = null;
  var bajkaUploadedFor = null; // file signature for which the upload has already been done
  var bajkaPhotoUploadPromise = null;
  var bajkaStep1PhotoObjectUrl = ""; // blob URL for step-1 upload preview (revoke on replace)

  function normalizeHairSelection(value) {
    var legacyMap = {
      łyse: "krótkie",
      "bardzo krótkie": "krótkie",
      "za ucho": "średnie",
      "do ramion": "średnie",
      "do klatki": "długie",
      "do pasa — bardzo długie": "bardzo długie",
      short: "krótkie",
      medium: "średnie",
      long: "długie",
      very_long: "bardzo długie",
      Short: "krótkie",
      Medium: "średnie",
      Long: "długie",
      "very long": "bardzo długie",
      "Very long": "bardzo długie",
    };
    return legacyMap[value] || value;
  }

  function normalizeGenderSelection(value) {
    var legacyMap = {
      male: "Chłopiec",
      female: "Dziewczyna",
      boy: "Chłopiec",
      girl: "Dziewczyna",
      Boy: "Chłopiec",
      Girl: "Dziewczyna",
      Dziewczynka: "Dziewczyna",
    };
    return legacyMap[value] || value;
  }

  function genderSelection() {
    return normalizeGenderSelection(selectedOption("gender"));
  }

  function normalizeEyeSelection(value) {
    var legacyMap = {
      brown: "Brąz",
      blue: "Niebieski",
      hazel: "Piwny",
      green: "Zielony",
      gray: "Szary",
      grey: "Szary",
      "gray-blue": "Szaroniebieski",
      "grey-blue": "Szaroniebieski",
      turquoise: "Szaroniebieski",
      Brown: "Brąz",
      Blue: "Niebieski",
      Hazel: "Piwny",
      Green: "Zielony",
      Grey: "Szary",
      Gray: "Szary",
      "Grey-blue": "Szaroniebieski",
      "Gray-blue": "Szaroniebieski",
      Orzechowy: "Piwny",
      Turkusowy: "Szaroniebieski",
    };
    return legacyMap[value] || value;
  }

  function bajkaVisibleCartProps() {
    if (BAJKA_BOOK_LANGUAGE === "en") {
      return {
        gender: "Gender",
        age: "Age",
        hair: "Hair length",
        eyes: "Eye colour",
        photo: "Photo",
        dedicationTitle: "Dedication title",
        message: "Message",
        signature: "Signature",
        header: "Header",
        familyPhoto: "Family photo",
      };
    }
    return {
      gender: BAJKA_I18N.cartPropGender,
      age: BAJKA_I18N.cartPropAge,
      hair: BAJKA_I18N.cartPropHair,
      eyes: BAJKA_I18N.cartPropEyes,
      photo: BAJKA_I18N.cartPropPhoto,
      dedicationTitle: BAJKA_I18N.cartPropDedicationTitle,
      message: BAJKA_I18N.cartPropMessage,
      signature: BAJKA_I18N.cartPropSignature,
      header: BAJKA_I18N.cartPropHeader,
      familyPhoto: BAJKA_I18N.cartPropFamilyPhoto,
    };
  }

  function bajkaCartPropName(internalName) {
    var keys = bajkaVisibleCartProps();
    var remap = {
      "Tytuł dedykacji": keys.dedicationTitle,
      Wiadomość: keys.message,
      Dedykacja: keys.message,
      Podpis: keys.signature,
      "Wystawione przez": keys.signature,
      Nagłówek: keys.header,
      "Zdjęcie rodzinne": keys.familyPhoto,
    };
    return remap[internalName] || internalName;
  }

  function bajkaCartPropValue(props, internalName) {
    return props[bajkaCartPropName(internalName)] || props[internalName] || "";
  }

  function dedicationGenderKey() {
    var gender = genderSelection();
    if (gender === "Dziewczyna") return "girl";
    if (gender === "Chłopiec") return "boy";
    return "boy";
  }

  function updateDedicationDefaults() {
    var textarea = wizard.querySelector("[data-bajka-dedication]");
    if (!textarea) return;
    var defaults = DEDICATION_DEFAULTS[dedicationGenderKey()];
    if (!defaults) return;
    var current = textarea.value.trim();
    if (!current || DEDICATION_DEFAULT_MESSAGES.indexOf(current) !== -1) {
      textarea.value = defaults.message;
    }
    textarea.placeholder = defaults.placeholder;
  }

  function updateHairTierPreviews() {
    var gender = selectedOption("gender") === "Chłopiec" ? "boy" : "girl";
    wizard.querySelectorAll("[data-hair-preview]").forEach(function (img) {
      var src = img.getAttribute(
        gender === "boy" ? "data-src-boy" : "data-src-girl",
      );
      if (src && img.getAttribute("src") !== src) {
        img.setAttribute("src", src);
      }
    });
    updateDedicationDefaults();
  }

  function bajkaProductHandle() {
    var t = document.querySelector(
      "[data-bajka-wizard-open][data-product-handle]",
    );
    return t ? t.getAttribute("data-product-handle") || "" : "";
  }

  // Generates a secure random filename (extension is preserved).
  // Verhindert kaputte S3-Keys/Signaturen durch Sonderzeichen/Unicode/Leerzeichen.
  function bajkaRandomFileName(file) {
    var ext = "";
    var name = (file && file.name) || "";
    var dot = name.lastIndexOf(".");
    if (dot > -1 && dot < name.length - 1) {
      ext = name
        .slice(dot + 1)
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");
    }
    if (!ext) {
      var t = ((file && file.type) || "").toLowerCase();
      if (t.indexOf("jpeg") > -1 || t.indexOf("jpg") > -1) ext = "jpg";
      else if (t.indexOf("png") > -1) ext = "png";
      else if (t.indexOf("webp") > -1) ext = "webp";
      else if (t.indexOf("heic") > -1) ext = "heic";
      else if (t.indexOf("gif") > -1) ext = "gif";
      else ext = "jpg";
    }
    // Short random part (10 hex chars) – the server prepends its own UUID anyway.
    var rand = "xxxxxxxxxx".replace(/x/g, function () {
      return Math.floor(Math.random() * 16).toString(16);
    });
    return "photo-" + rand + "." + ext;
  }

  // Kern-Upload: POST -> presigned putUrl -> S3 PUT; liefert den S3-Key (ohne Caching/Seiteneffekt)
  function bajkaUploadFileRaw(file) {
    return window.ChildbookStorefrontSession.fetch(UPLOAD_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        fileName: bajkaRandomFileName(file),
        contentType: file.type,
      }),
    })
      .catch(function (e) {
        throw new Error(
          BAJKA_I18N.uploadConnectError +
            " " +
            (e && e.message ? e.message : e) +
            " [Origin: " +
            location.origin +
            "]",
        );
      })
      .then(function (res) {
        if (!res.ok)
          throw new Error(
            BAJKA_I18N.uploadUrlError.replace("%{status}", res.status),
          );
        return res.json();
      })
      .then(function (data) {
        return fetch(data.putUrl, {
          method: "PUT",
          body: file,
          headers: { "Content-Type": file.type },
        })
          .catch(function (e) {
            throw new Error(
              BAJKA_I18N.uploadStorageError +
                " " +
                (e && e.message ? e.message : e),
            );
          })
          .then(function (put) {
            if (!put.ok)
              throw new Error(
                BAJKA_I18N.uploadFailed.replace("%{status}", put.status),
              );
            return data.key;
          });
      });
  }

  function bajkaUploadPhoto(file) {
    var sig = file.name + ":" + file.size + ":" + file.lastModified;
    if (bajkaUploadedKey && bajkaUploadedFor === sig)
      return Promise.resolve(bajkaUploadedKey);
    if (bajkaPhotoUploadPromise) return bajkaPhotoUploadPromise;
    // Upload endpoint does NOT require a Turnstile token (confirmed via curl: empty token -> 200).
    bajkaPhotoUploadPromise = bajkaUploadFileRaw(file)
      .then(function (key) {
        bajkaUploadedKey = key;
        bajkaUploadedFor = sig;
        return key;
      })
      .finally(function () {
        bajkaPhotoUploadPromise = null;
      });
    return bajkaPhotoUploadPromise;
  }

  // Original (uncropped) photo: same upload flow as the face crop, stored per
  // character and sent as a hidden order-item property (_original_photo_url),
  // so a wrong crop can be checked against the source photo later.
  function bajkaEnsureOriginalUpload(character) {
    var file = character && character.file;
    if (!file) return Promise.resolve(null);
    var sig = file.name + ":" + file.size + ":" + file.lastModified;
    if (character.originalKey && character.originalFor === sig)
      return Promise.resolve(character.originalKey);
    if (character.originalPromise && character.originalPromiseFor === sig)
      return character.originalPromise;
    var promise = bajkaUploadFileRaw(file)
      .then(function (key) {
        character.originalKey = key;
        character.originalFor = sig;
        return key;
      })
      .finally(function () {
        if (character.originalPromise === promise)
          character.originalPromise = null;
      });
    character.originalPromise = promise;
    character.originalPromiseFor = sig;
    return promise;
  }

  function bajkaEnsureAllOriginalUploads() {
    return Promise.all(
      bajkaCharacters
        .filter(function (character) {
          return character && character.file;
        })
        .map(function (character) {
          return bajkaEnsureOriginalUpload(character);
        }),
    );
  }

  var previewBtn = wizard.querySelector("[data-bajka-preview-create]");
  if (previewBtn) {
    previewBtn.addEventListener("click", function () {
      if (bajkaIsMultiCharacter()) {
        bajkaCaptureCurrentCharacter();
        if (!bajkaCharacterIsValid(bajkaCharacters[bajkaCharacterIndex]))
          return;
        if (bajkaCharacterIndex < bajkaCharacters.length - 1) {
          bajkaLoadCharacter(bajkaCharacterIndex + 1);
          return;
        }
        var allValid = bajkaCharacters.every(bajkaCharacterIsValid);
        if (!allValid) {
          validateStep1BeforeCart();
          return;
        }
      }
      goToStep(2);
      if (bajkaHasCachedPreview()) {
        window.BajkaWizardPreview.showCached();
        return;
      }
      bajkaGeneratePreview();
    });
  }

  // "Next" buttons -> target step (step 4 validates extras before advancing)
  wizard.querySelectorAll("[data-bajka-next]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var target = btn.getAttribute("data-bajka-next");
      if (target === "5") {
        var step4 = getStep4Validation();
        if (!step4.valid) {
          highlightMissingExtraField(step4.firstMissing);
          return;
        }
      }
      goToStep(target);
      if (target === "5" && crossOfferPrimaryAdded) reopenCrossPopup();
    });
  });

  // Product cards (step 3) + layflat upsell
  var upsell = wizard.querySelector("[data-bajka-upsell]");
  var upsellPriceEl = wizard.querySelector("[data-bajka-upsell-price]");
  var layflatToggle = wizard.querySelector("[data-bajka-layflat-toggle]");
  var selectedCard = null;

  function updateSelectedVariant() {
    if (!selectedCard) return;
    var hasLayflat = selectedCard.getAttribute("data-variant-layflat");
    var useLayflat = layflatToggle && layflatToggle.checked && hasLayflat;
    var id = useLayflat
      ? selectedCard.getAttribute("data-variant-layflat")
      : selectedCard.getAttribute("data-variant-normal");
    wizard.setAttribute("data-selected-variant", id || "");
  }

  // Goldener Glow + Badge, wenn Layflat aktiv ist
  function updateLayflatVisual() {
    if (!upsell) return;
    var on = !!(layflatToggle && layflatToggle.checked);
    upsell.classList.toggle("is-active", on);
    var badge = upsell.querySelector("[data-bajka-upsell-badge]");
    if (badge) badge.hidden = !on;
  }

  function selectCard(card, doScroll) {
    var group = card.closest("[data-bajka-products]");
    if (!group) return;
    group.querySelectorAll(".bajka-product").forEach(function (c) {
      c.classList.remove("is-selected");
    });
    card.classList.add("is-selected");
    selectedCard = card;

    // Format selected -> activate "Next" in step 3
    var step3Next = wizard.querySelector('[data-bajka-next="4"]');
    if (step3Next) step3Next.disabled = false;

    // Show upsell below as soon as a book is selected
    var layflatId = card.getAttribute("data-variant-layflat");
    var surcharge = card.getAttribute("data-surcharge");
    if (upsell) {
      if (layflatId) {
        if (layflatToggle) layflatToggle.checked = false;
        if (upsellPriceEl)
          upsellPriceEl.textContent = surcharge ? "+ " + surcharge : "";
        upsell.hidden = false;
      } else {
        upsell.hidden = true;
      }
    }
    updateSelectedVariant();
    updateLayflatVisual();

    // After selection, smoothly scroll to upsell / "Next"
    if (doScroll) {
      var panel = card.closest("[data-step-panel]");
      var st =
        upsell && !upsell.hidden
          ? upsell
          : panel && panel.querySelector(".bajka-step__nav");
      if (st && st.scrollIntoView) {
        setTimeout(function () {
          st.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 120);
      }
    }
  }

  wizard.addEventListener("click", function (e) {
    var card = e.target.closest(".bajka-product");
    if (!card || !wizard.contains(card)) return;
    if (card.closest("[data-bajka-products]")) {
      // Format: single selection (with smooth scrolling)
      selectCard(card, true);
    } else if (card.closest("[data-bajka-extras]")) {
      // Do not count clicks inside input fields as selection
      if (e.target.closest(".bajka-extra-fields")) return;
      // Extras: independently on/off
      card.classList.toggle("is-selected");
      var fields = card.querySelector(".bajka-extra-fields");
      var nowSelected = card.classList.contains("is-selected");
      if (fields) fields.hidden = !nowSelected;
      checkStep4();
      // Smoothly scroll to the input fields on activation
      if (nowSelected) {
        var scrollEl = fields || card;
        if (scrollEl.scrollIntoView) {
          setTimeout(function () {
            scrollEl.scrollIntoView({ behavior: "smooth", block: "center" });
          }, 120);
        }
      }
    }
  });

  if (layflatToggle) {
    layflatToggle.addEventListener("change", function () {
      updateSelectedVariant();
      updateLayflatVisual();
    });
  }

  /* --- Step 5: order summary --- */
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function formatMoney(cents) {
    cents = Number(cents) || 0;
    var settings = window.theme && window.theme.settings;
    var format =
      settings &&
      settings.currencyCodeEnabled &&
      settings.moneyWithCurrencyFormat
        ? settings.moneyWithCurrencyFormat
        : (settings && settings.moneyFormat) || "";
    if (
      window.theme &&
      window.theme.Currency &&
      window.theme.Currency.formatMoney &&
      format
    ) {
      return window.theme.Currency.formatMoney(cents, format);
    }
    return (cents / 100).toFixed(2).replace(".", ",") + " zł";
  }
  function summaryRow(label, valueHtml) {
    return (
      '<div class="bajka-summary__row"><span>' +
      esc(label) +
      "</span><span>" +
      valueHtml +
      "</span></div>"
    );
  }
  function selectedOption(field) {
    var el = wizard.querySelector(
      '[data-field="' + field + '"] .bajka-option.is-selected',
    );
    return el ? el.getAttribute("data-value") : "–";
  }

  // Age is a numeric input field
  function ageValue() {
    var el = wizard.querySelector("#bajka-age");
    return el && el.value.trim() !== "" ? el.value.trim() : "";
  }

  var PENCIL =
    '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>';

  function buildSummary() {
    var summaryEl = wizard.querySelector("[data-bajka-summary]");
    if (!summaryEl) return;

    var nameEl = wizard.querySelector("#bajka-name");
    var photoInputEl = wizard.querySelector("#bajka-photo");

    // Derive dropdown options from step 1
    function buildSelect(field) {
      var current = selectedOption(field);
      var out =
        '<select class="bajka-edit__input" data-edit-option="' + field + '">';
      wizard
        .querySelectorAll('[data-field="' + field + '"] .bajka-option')
        .forEach(function (o) {
          var v = o.getAttribute("data-value");
          out +=
            '<option value="' +
            esc(v) +
            '"' +
            (v === current ? " selected" : "") +
            ">" +
            esc(bajkaOptionLabel(v)) +
            "</option>";
        });
      return out + "</select>";
    }
    // Format options from the product cards
    var currentTitle = selectedCard
      ? selectedCard.getAttribute("data-title")
      : "";
    var formatOpts = "";
    wizard
      .querySelectorAll("[data-bajka-products] .bajka-product")
      .forEach(function (c) {
        var t = c.getAttribute("data-title");
        formatOpts +=
          '<option value="' +
          esc(t) +
          '"' +
          (t === currentTitle ? " selected" : "") +
          ">" +
          esc(t) +
          "</option>";
      });
    var hasLayflat =
      selectedCard && selectedCard.getAttribute("data-variant-layflat");
    var layflatChecked = layflatToggle && layflatToggle.checked;

    var html = "";

    html += '<div class="bajka-summary__groups">';

    // --- Your hero ---
    if (bajkaIsMultiCharacter()) {
      bajkaCaptureCurrentCharacter();
      bajkaCharacters.forEach(function (character, index) {
        html += '<div class="bajka-summary__group">';
        html +=
          '<div class="bajka-summary__head"><p class="bajka-summary__group-title">' +
          esc(BAJKA_I18N.yourHero + " " + (index + 1)) +
          "</p>" +
          '<button type="button" class="bajka-summary__edit" data-edit-character-index="' +
          index +
          '" aria-label="' +
          esc(BAJKA_I18N.edit) +
          '">' +
          PENCIL +
          "</button></div>";
        html += '<div class="bajka-summary__body">';
        html +=
          '<img class="bajka-summary__photo" data-sum-character-photo="' +
          index +
          '" alt="" hidden>';
        html += '<div class="bajka-summary__info">';
        html +=
          '<div class="bajka-summary__value bajka-summary__value--name">' +
          esc(character.name || "–") +
          "</div>";
        html +=
          '<div class="bajka-summary__value">' +
          esc(character.age ? bajkaFormatAge(Number(character.age)) : "–") +
          "</div>";
        html +=
          '<div class="bajka-summary__value">' +
          esc(BAJKA_I18N.hairLength + ": " + bajkaOptionLabel(character.hair)) +
          "</div>";
        html +=
          '<div class="bajka-summary__value">' +
          esc(BAJKA_I18N.eyesPrefix + " " + bajkaOptionLabel(character.eyes)) +
          "</div>";
        html += "</div></div></div>";
      });
    } else {
      html += '<div class="bajka-summary__group">';
      html +=
        '<div class="bajka-summary__head"><p class="bajka-summary__group-title">' +
        esc(BAJKA_I18N.yourHero) +
        "</p>";
      html +=
        '<button type="button" class="bajka-summary__edit" data-edit-toggle="hero" aria-label="' +
        esc(BAJKA_I18N.edit) +
        '">' +
        PENCIL +
        "</button></div>";
      html += '<div class="bajka-summary__body">';
      html +=
        '<img class="bajka-summary__photo" data-sum="photo-img" alt="" hidden>';
      html += '<div class="bajka-summary__info">';
      html +=
        '<div class="bajka-summary__value bajka-summary__value--name"><span data-sum="name"></span><span class="bajka-summary__gender-icon" data-sum="gender-icon"></span></div>';
      html += '<div class="bajka-summary__value" data-sum="age"></div>';
      html += '<div class="bajka-summary__value" data-sum="hair"></div>';
      html += '<div class="bajka-summary__value" data-sum="eyes"></div>';
      html += "</div></div>";
      html += '<div class="bajka-edit" data-edit-form="hero" hidden>';
      html +=
        '<label class="bajka-edit__label">' +
        esc(BAJKA_I18N.name) +
        '<input type="text" class="bajka-edit__input" data-edit-name value="' +
        esc(nameEl ? nameEl.value : "") +
        '"></label>';
      html +=
        '<label class="bajka-edit__label">' +
        esc(BAJKA_I18N.gender) +
        buildSelect("gender") +
        "</label>";
      html +=
        '<label class="bajka-edit__label">' +
        esc(BAJKA_I18N.age) +
        '<input type="number" class="bajka-edit__input" data-edit-age min="0" max="17" step="1" inputmode="numeric" value="' +
        esc(ageValue()) +
        '"></label>';
      html +=
        '<label class="bajka-edit__label">' +
        esc(BAJKA_I18N.hairLength) +
        buildSelect("hair") +
        "</label>";
      html +=
        '<label class="bajka-edit__label">' +
        esc(BAJKA_I18N.eyeColour) +
        buildSelect("eyes") +
        "</label>";
      html +=
        '<div class="bajka-edit__photo">' +
        '<span class="bajka-edit__label">' +
        esc(BAJKA_I18N.photo) +
        "</span>" +
        '<label class="bajka-upload bajka-upload--compact">' +
        '<input type="file" accept="image/*" class="bajka-upload__input" data-edit-photo>' +
        '<span class="bajka-upload__box">' +
        '<img class="bajka-upload__preview" data-edit-photo-preview alt="" hidden>' +
        '<span class="bajka-upload__placeholder" data-edit-photo-placeholder>' +
        '<span class="bajka-upload__icon">📷</span>' +
        '<span class="bajka-upload__text">' +
        esc(BAJKA_I18N.changePhoto) +
        "</span>" +
        "</span>" +
        "</span>" +
        "</label>" +
        '<p class="bajka-upload__filename" data-edit-photo-filename hidden></p>' +
        "</div>";
      html +=
        '<button type="button" class="bajka-edit__save" data-edit-save>' +
        esc(BAJKA_I18N.save) +
        "</button>";
      html += "</div></div>";
    }

    // --- Your book ---
    html += '<div class="bajka-summary__group">';
    html +=
      '<div class="bajka-summary__head"><p class="bajka-summary__group-title">' +
      esc(BAJKA_I18N.yourBook) +
      "</p>";
    html +=
      '<button type="button" class="bajka-summary__edit" data-edit-toggle="book" aria-label="' +
      esc(BAJKA_I18N.edit) +
      '">' +
      PENCIL +
      "</button></div>";
    html += '<div class="bajka-summary__body">';
    html +=
      '<img class="bajka-summary__book-img" data-sum="book-img" alt="" hidden>';
    html += '<div class="bajka-summary__info">';
    html +=
      '<div class="bajka-summary__value bajka-summary__value--name" data-sum="book-title"></div>';
    html += '<div class="bajka-summary__value" data-sum="book-label"></div>';
    html += "</div></div>";
    html += "</div>";

    html += "</div>"; // .bajka-summary__groups

    // --- Price breakdown ---
    html += '<div class="bajka-summary__breakdown" data-sum="breakdown"></div>';

    summaryEl.innerHTML = html;

    function set(key, text) {
      var el = summaryEl.querySelector('[data-sum="' + key + '"]');
      if (el) el.textContent = text;
    }
    function refresh() {
      if (bajkaIsMultiCharacter()) {
        bajkaCharacters.forEach(function (character, index) {
          var characterImage = summaryEl.querySelector(
            '[data-sum-character-photo="' + index + '"]',
          );
          if (!characterImage) return;
          var characterPhotoSrc = character.file
            ? URL.createObjectURL(character.file)
            : resolvePhotoSrc(character.photoUrl || character.uploadedKey);
          if (characterPhotoSrc) {
            characterImage.src = characterPhotoSrc;
            characterImage.hidden = false;
          } else {
            characterImage.hidden = true;
          }
        });
      }
      set("name", (nameEl && nameEl.value.trim()) || "–");
      var genderIconHolder = summaryEl.querySelector(
        '[data-sum="gender-icon"]',
      );
      if (genderIconHolder) {
        var selGender = wizard.querySelector(
          '[data-field="gender"] .bajka-option.is-selected',
        );
        var gSvg = selGender && selGender.querySelector("svg");
        genderIconHolder.innerHTML = gSvg ? gSvg.outerHTML : "";
      }
      var ageV = ageValue();
      set("age", ageV ? bajkaFormatAge(Number(ageV)) : "–");
      var hairV = selectedOption("hair");
      set(
        "hair",
        hairV && hairV !== "–"
          ? BAJKA_I18N.hairLength + ": " + bajkaOptionLabel(hairV)
          : "",
      );
      var eyesV = selectedOption("eyes");
      set(
        "eyes",
        eyesV && eyesV !== "–"
          ? BAJKA_I18N.eyesPrefix + " " + bajkaOptionLabel(eyesV)
          : "",
      );
      var photoFile =
        photoInputEl && photoInputEl.files && photoInputEl.files[0];
      var img = summaryEl.querySelector('[data-sum="photo-img"]');
      if (img) {
        if (photoFile) {
          img.src = URL.createObjectURL(photoFile);
          img.hidden = false;
        } else if (bajkaHeldFallbackImage) {
          img.src = bajkaHeldFallbackImage;
          img.hidden = false;
        } else {
          var preservedPhotoSrc = resolvePhotoSrc(bajkaPreservedPhotoUrl);
          if (preservedPhotoSrc) {
            img.src = preservedPhotoSrc;
            img.hidden = false;
          } else {
            img.hidden = true;
          }
        }
      }
      var editPreview = summaryEl.querySelector("[data-edit-photo-preview]");
      var editPlaceholder = summaryEl.querySelector(
        "[data-edit-photo-placeholder]",
      );
      var editFilename = summaryEl.querySelector("[data-edit-photo-filename]");
      if (editPreview) {
        var editSrc = "";
        if (photoFile) {
          editSrc = URL.createObjectURL(photoFile);
        } else if (bajkaHeldFallbackImage) {
          editSrc = bajkaHeldFallbackImage;
        } else {
          editSrc =
            resolvePhotoSrc(bajkaPreservedPhotoUrl) ||
            resolvePhotoSrc(bajkaUploadedKey) ||
            "";
        }
        if (editSrc) {
          editPreview.src = editSrc;
          editPreview.hidden = false;
          if (editPlaceholder) editPlaceholder.hidden = true;
          if (editFilename) {
            editFilename.textContent = photoFile
              ? photoFile.name
              : bajkaPreservedPhotoName || BAJKA_I18N.photo;
            editFilename.hidden = false;
          }
        } else {
          editPreview.hidden = true;
          if (editPlaceholder) editPlaceholder.hidden = false;
          if (editFilename) editFilename.hidden = true;
        }
      }
      var bookTitle = "–",
        useLayflat = false,
        basePrice = 0,
        layflatSurcharge = 0;
      if (selectedCard) {
        bookTitle =
          selectedCard.getAttribute("data-title") || BAJKA_I18N.bookFallback;
        basePrice = Number(selectedCard.getAttribute("data-price-normal")) || 0;
        useLayflat = !!(
          layflatToggle &&
          layflatToggle.checked &&
          selectedCard.getAttribute("data-variant-layflat")
        );
        if (useLayflat) {
          var lp =
            Number(selectedCard.getAttribute("data-price-layflat")) ||
            basePrice;
          layflatSurcharge = lp - basePrice;
        }
      }
      set(
        "book-title",
        (themeTitleEl && themeTitleEl.textContent.trim()) || "",
      );
      set("book-label", bookTitle);
      var bookImg = summaryEl.querySelector('[data-sum="book-img"]');
      if (bookImg) {
        // Always use the default product image, regardless of the selected variant
        var src = bajkaDefaultBookImage;
        if (!src) {
          var t = document.querySelector(
            "[data-bajka-wizard-open][data-product-image]",
          );
          src = t && t.getAttribute("data-product-image");
        }
        if (src) {
          bookImg.src = src;
          bookImg.hidden = false;
        } else {
          bookImg.hidden = true;
        }
      }

      // --- Price breakdown ---
      var total = basePrice + layflatSurcharge;
      var bd = "";
      bd +=
        '<div class="bajka-summary__bd-row"><span>' +
        esc(bookTitle) +
        "</span><span>" +
        esc(formatMoney(basePrice)) +
        "</span></div>";
      if (useLayflat) {
        bd +=
          '<div class="bajka-summary__bd-row"><span>' +
          esc(BAJKA_I18N.layflatBinding) +
          "</span><span>+ " +
          esc(formatMoney(layflatSurcharge)) +
          "</span></div>";
      }
      wizard
        .querySelectorAll("[data-bajka-extras] .bajka-product.is-selected")
        .forEach(function (c) {
          var price = Number(c.getAttribute("data-price")) || 0;
          total += price;
          bd +=
            '<div class="bajka-summary__bd-row">' +
            "<span>" +
            esc(c.getAttribute("data-title") || "Extra") +
            "</span>" +
            '<span class="bajka-summary__extra-right">' +
            "<span>" +
            esc(formatMoney(price)) +
            "</span>" +
            '<button type="button" class="bajka-summary__remove" data-bajka-remove-extra="' +
            esc(c.getAttribute("data-variant-id") || "") +
            '" aria-label="' +
            esc(BAJKA_I18N.remove) +
            '">&times;</button>' +
            "</span></div>";
        });
      bd +=
        '<div class="bajka-summary__bd-row">' +
        '<span class="bajka-summary__ship-label">' +
        BAJKA_I18N.shippingHtml.replace("%{old}", esc(formatMoney(2000))) +
        "</span>" +
        "<span>" +
        esc(formatMoney(0)) +
        "</span>" +
        "</div>";
      bd +=
        '<div class="bajka-summary__bd-total"><span>' +
        esc(BAJKA_I18N.total) +
        "</span><span>" +
        esc(formatMoney(total)) +
        "</span></div>";
      var bdEl = summaryEl.querySelector('[data-sum="breakdown"]');
      if (bdEl) bdEl.innerHTML = bd;
    }

    // Stift -> Bearbeiten-Feld auf/zu
    summaryEl
      .querySelectorAll("[data-edit-character-index]")
      .forEach(function (btn) {
        btn.addEventListener("click", function () {
          bajkaCaptureCurrentCharacter();
          bajkaLoadCharacter(
            Number(btn.getAttribute("data-edit-character-index")) || 0,
          );
          goToStep(1);
        });
      });
    summaryEl.querySelectorAll("[data-edit-toggle]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var target = btn.getAttribute("data-edit-toggle");
        if (target === "book") {
          goToStep(3);
          return;
        }
        var form = summaryEl.querySelector('[data-edit-form="' + target + '"]');
        if (form) form.hidden = !form.hidden;
      });
    });

    // "Save" -> close edit field (values already applied live)
    summaryEl.querySelectorAll("[data-edit-save]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var form = btn.closest("[data-edit-form]");
        if (form) form.hidden = true;
      });
    });

    // Name
    var editName = summaryEl.querySelector("[data-edit-name]");
    if (editName)
      editName.addEventListener("input", function () {
        if (nameEl) nameEl.value = editName.value;
        bajkaInvalidatePreviewCache();
        refresh();
      });
    // Age
    var editAge = summaryEl.querySelector("[data-edit-age]");
    if (editAge)
      editAge.addEventListener("input", function () {
        var ageEl = wizard.querySelector("#bajka-age");
        if (ageEl) ageEl.value = editAge.value;
        bajkaInvalidatePreviewCache();
        refresh();
      });
    // Gender/hair/eyes -> set selection in step 1
    summaryEl.querySelectorAll("[data-edit-option]").forEach(function (sel) {
      sel.addEventListener("change", function () {
        var field = sel.getAttribute("data-edit-option");
        wizard
          .querySelectorAll('[data-field="' + field + '"] .bajka-option')
          .forEach(function (o) {
            o.classList.toggle(
              "is-selected",
              o.getAttribute("data-value") === sel.value,
            );
          });
        if (field === "gender") {
          updateHairTierPreviews();
        }
        bajkaInvalidatePreviewCache();
        refresh();
      });
    });
    // Photo -> set original input
    var editPhoto = summaryEl.querySelector("[data-edit-photo]");
    if (editPhoto)
      editPhoto.addEventListener("change", function () {
        var f = editPhoto.files && editPhoto.files[0];
        if (f && photoInputEl) {
          try {
            var dt = new DataTransfer();
            dt.items.add(f);
            photoInputEl.files = dt.files;
          } catch (err) {}
          bajkaPreservedPhotoUrl = "";
          bajkaPreservedPhotoName = "";
          bajkaUploadedKey = null;
          bajkaUploadedFor = null;
          bajkaInvalidatePreviewCache();
        }
        restoreStep1PhotoPreview();
        refresh();
      });
    // Format -> select the matching card
    var editFormat = summaryEl.querySelector("[data-edit-format]");
    if (editFormat)
      editFormat.addEventListener("change", function () {
        var keepLayflat = layflatToggle && layflatToggle.checked;
        var target = null;
        wizard
          .querySelectorAll("[data-bajka-products] .bajka-product")
          .forEach(function (c) {
            if (c.getAttribute("data-title") === editFormat.value) target = c;
          });
        if (target) {
          selectCard(target);
          if (layflatToggle)
            layflatToggle.checked = !!(
              keepLayflat && target.getAttribute("data-variant-layflat")
            );
          updateSelectedVariant();
        }
        refresh();
      });
    // Layflat
    var editLayflat = summaryEl.querySelector("[data-edit-layflat]");
    if (editLayflat)
      editLayflat.addEventListener("change", function () {
        if (layflatToggle) layflatToggle.checked = editLayflat.checked;
        updateSelectedVariant();
        refresh();
      });

    refresh();
  }

  /* --- Cart + cross-sell popup --- */
  // Tier by book position: 1st full, 2nd −15%, 3rd −20%, 4th+ −25%.
  function discountPctForBookPosition(position) {
    if (position >= 4) return 25;
    if (position === 3) return 20;
    if (position === 2) return 15;
    return 0;
  }

  var cartBajkaBookCount = 0;

  function isCartBajkaBook(item) {
    var props = item && item.properties;
    return !!(props && (props._bajka === "1" || props._bajka === 1));
  }

  function refreshCartBajkaCounts() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (response) {
        if (!response.ok) throw new Error("cart.js failed");
        return response.json();
      })
      .then(function (cart) {
        var bajkaItems = (cart.items || []).filter(isCartBajkaBook);
        cartBajkaBookCount = bajkaItems.reduce(function (sum, item) {
          return sum + (item.quantity || 0);
        }, 0);
        return cart;
      })
      .catch(function () {
        cartBajkaBookCount = 0;
        return null;
      });
  }

  var crossPopup = wizard.querySelector("[data-bajka-cross-popup]");

  function gatherProperties(themeOverride) {
    if (bajkaIsMultiCharacter()) {
      bajkaCaptureCurrentCharacter();
      var multiProps = {
        _bajka: "1",
        _waited_for_preview: window.BajkaWizardPreview.waitedForPreview()
          ? "yes"
          : "no",
        _theme: themeOverride || bajkaCurrentTheme || "",
        _language: bajkaSelectedBookLanguage(),
        _character_schema_version: "1",
        _character_count: String(bajkaCharacters.length),
      };
      bajkaCharacters.forEach(function (character, index) {
        var number = index + 1;
        var visiblePrefix =
          (BAJKA_BOOK_LANGUAGE === "pl" ? "Postać " : "Character ") +
          number +
          " — ";
        multiProps[visiblePrefix + BAJKA_I18N.name] = character.name;
        multiProps[visiblePrefix + BAJKA_I18N.gender] = bajkaOptionLabel(
          character.gender,
        );
        multiProps[visiblePrefix + BAJKA_I18N.age] = character.age;
        multiProps[visiblePrefix + BAJKA_I18N.hairLength] = bajkaOptionLabel(
          character.hair,
        );
        multiProps[visiblePrefix + BAJKA_I18N.eyeColour] = bajkaOptionLabel(
          character.eyes,
        );
        if (character.photoName)
          multiProps[visiblePrefix + BAJKA_I18N.photo] = character.photoName;

        var hiddenPrefix = "_character" + number + "_";
        multiProps[hiddenPrefix + "slot"] = character.slotKey;
        multiProps[hiddenPrefix + "child_name"] = character.name;
        multiProps[hiddenPrefix + "child_age"] = character.age;
        multiProps[hiddenPrefix + "gender"] =
          GENDER_MAP[normalizeGenderSelection(character.gender)] || "";
        multiProps[hiddenPrefix + "eye_color"] =
          EYE_COLOR_MAP[character.eyes] || "";
        multiProps[hiddenPrefix + "hair_length"] =
          HAIR_LENGTH_MAP[character.hair] || "";
        if (character.uploadedKey || character.photoUrl) {
          multiProps[hiddenPrefix + "photo_url"] =
            character.uploadedKey || character.photoUrl;
        }
        if (character.originalKey) {
          multiProps[hiddenPrefix + "original_photo_url"] =
            character.originalKey;
        }
      });
      return multiProps;
    }
    var nameEl = wizard.querySelector("#bajka-name");
    var photoInputEl = wizard.querySelector("#bajka-photo");
    var photoFile = photoInputEl && photoInputEl.files && photoInputEl.files[0];
    var genderValue = genderSelection();
    var hairValue = selectedOption("hair");
    var eyesValue = selectedOption("eyes");
    var age = ageValue();
    var cartKeys = bajkaVisibleCartProps();
    var props = {
      _bajka: "1",
      Name: (nameEl && nameEl.value.trim()) || "",
      _waited_for_preview: window.BajkaWizardPreview.waitedForPreview()
        ? "yes"
        : "no",
    };
    props[cartKeys.gender] = bajkaOptionLabel(genderValue);
    props[cartKeys.age] = age;
    props[cartKeys.hair] = bajkaOptionLabel(hairValue);
    props[cartKeys.eyes] = bajkaOptionLabel(eyesValue);
    if (photoFile) {
      props[cartKeys.photo] = photoFile.name;
    } else if (bajkaPreservedPhotoName) {
      props[cartKeys.photo] = bajkaPreservedPhotoName;
    }
    // Theme (hidden) – from bajkaCurrentTheme for the main book, from the card theme for cross-sell
    var theme = themeOverride || bajkaCurrentTheme;
    props["_theme"] = theme || "";
    // --- Backend keys (hidden, PARALLEL to the visible ones) ---
    props["_child_name"] = props["Name"];
    props["_child_age"] = age;
    props["_gender"] = GENDER_MAP[genderValue] || ""; // male / female
    props["_eye_color"] = EYE_COLOR_MAP[eyesValue] || ""; // english
    props["_hair_length"] = HAIR_LENGTH_MAP[hairValue] || ""; // english
    props["_language"] = bajkaSelectedBookLanguage();
    // Child photo S3 key (remembered after upload). Only _photo_url on the book;
    // _final_photo_url ist dem Urkunde-Upsell (Familienfoto) vorbehalten.
    if (bajkaUploadedKey) {
      props["_photo_url"] = bajkaUploadedKey;
    } else if (bajkaPreservedPhotoUrl) {
      props["_photo_url"] = bajkaPreservedPhotoUrl;
    }
    // Original (uncropped) photo key, uploaded alongside the face crop
    var currentCharacter = bajkaCharacters[bajkaCharacterIndex];
    if (currentCharacter && currentCharacter.originalKey) {
      props["_original_photo_url"] = currentCharacter.originalKey;
    }
    // _group_id is set in addToCart (like _bajka_group)
    // Binding NOT as a property – already shown as a variant under the title
    return props;
  }

  function newBajkaGroupId() {
    return "bajka-" + Date.now() + "-" + Math.floor(Math.random() * 100000);
  }

  function selectedDedicationExtraCard() {
    var card = wizard.querySelector(
      "[data-bajka-extras] .bajka-product.is-selected [data-bajka-dedication]",
    );
    return card ? card.closest(".bajka-product") : null;
  }

  function selectedFinalPhotoExtraCard() {
    var card = wizard.querySelector(
      '[data-bajka-extras] .bajka-product.is-selected [data-prop="Zdjęcie rodzinne"]',
    );
    return card ? card.closest(".bajka-product") : null;
  }

  function crossCopyChecked(card, type) {
    var input =
      card && card.querySelector('[data-bajka-cross-copy="' + type + '"]');
    return !!(input && input.checked);
  }

  function updateCrossPersonalizationControls() {
    var dedicationExtraCard = selectedDedicationExtraCard();
    var finalPhotoExtraCard = selectedFinalPhotoExtraCard();
    var dedicationPrice = dedicationExtraCard
      ? formatMoney(dedicationExtraCard.getAttribute("data-price"))
      : "";
    var finalPhotoPrice = finalPhotoExtraCard
      ? formatMoney(finalPhotoExtraCard.getAttribute("data-price"))
      : "";
    var canCopyDedication = !!dedicationExtraCard;
    var canCopyFinalPhoto = !!finalPhotoExtraCard;
    wizard.querySelectorAll(".bajka-cross").forEach(function (card) {
      var previousDedication = crossCopyChecked(card, "dedication");
      var previousFinalPhoto = crossCopyChecked(card, "final-photo");
      var old = card.querySelector(".bajka-cross__personalization");
      if (old && old.parentNode) old.parentNode.removeChild(old);
      if (
        !card.classList.contains("is-selected") ||
        (!canCopyDedication && !canCopyFinalPhoto)
      )
        return;

      var box = document.createElement("div");
      box.className = "bajka-cross__personalization";
      box.setAttribute("data-bajka-cross-personalization", "");
      if (canCopyDedication) {
        box.innerHTML +=
          '<label class="bajka-cross__personalization-label">' +
          '<input type="checkbox" data-bajka-cross-copy="dedication"' +
          (previousDedication ? " checked" : "") +
          "> " +
          '<span class="bajka-cross__personalization-text">' +
          esc(BAJKA_ADD_SAME_DEDICATION_LABEL) +
          "</span>" +
          '<span class="bajka-cross__personalization-price">+ ' +
          esc(dedicationPrice) +
          "</span>" +
          "</label>";
      }
      if (canCopyFinalPhoto) {
        box.innerHTML +=
          '<label class="bajka-cross__personalization-label">' +
          '<input type="checkbox" data-bajka-cross-copy="final-photo"' +
          (previousFinalPhoto ? " checked" : "") +
          "> " +
          '<span class="bajka-cross__personalization-text">' +
          esc(BAJKA_ADD_SAME_FINAL_PHOTO_LABEL) +
          "</span>" +
          '<span class="bajka-cross__personalization-price">+ ' +
          esc(finalPhotoPrice) +
          "</span>" +
          "</label>";
      }
      card.appendChild(box);
    });
  }

  function appendPreviewToBookProps(props, groupId) {
    var previewImage = window.BajkaWizardPreview.lastImage();
    if (!previewImage) return;
    props["_preview"] = previewImage;
    try {
      localStorage.setItem("bajka_preview_" + groupId, previewImage);
    } catch (e) {}
  }

  function buildExtraCartItem(card, groupId, familyUploads) {
    var id = card && card.getAttribute("data-variant-id");
    if (!id) return null;
    var props = {
      _bajka_extra: "1",
      _bajka_group: groupId,
      _group_id: groupId,
    };
    var extraType = "";
    if (card.querySelector("[data-bajka-dedication]")) {
      extraType = "dedication";
    } else if (card.querySelector('[data-prop="Zdjęcie rodzinne"]')) {
      extraType = "final_photo";
    }
    if (extraType) props["_type"] = extraType;
    // Alle Eingabefelder dieses Extras einsammeln
    card.querySelectorAll("[data-prop]").forEach(function (inp) {
      var internalName = inp.getAttribute("data-prop");
      var name = bajkaCartPropName(internalName);
      if (inp.type === "file") {
        var f = inp.files && inp.files[0];
        if (f) props[name] = f.name;
      } else if (
        (inp.type === "radio" || inp.type === "checkbox") &&
        !inp.checked
      ) {
        return;
      } else if (inp.value && inp.value.trim() !== "") {
        var val = inp.value.trim();
        // Date (input[type=date] -> ISO YYYY-MM-DD) convert to display format DD.MM.YYYY
        if (inp.type === "date") {
          var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(val);
          if (m) val = m[3] + "." + m[2] + "." + m[1];
        }
        props[name] = val;
      }
    });
    // --- Backend-Keys (versteckt, parallel) ---
    var dedicationTitle = bajkaCartPropValue(props, "Tytuł dedykacji");
    var dedicationMessage =
      bajkaCartPropValue(props, "Wiadomość") ||
      bajkaCartPropValue(props, "Dedykacja");
    var dedicationFrom =
      bajkaCartPropValue(props, "Podpis") ||
      bajkaCartPropValue(props, "Wystawione przez");
    var finalPhotoMessage = bajkaCartPropValue(props, "Nagłówek");
    if (dedicationTitle) props["_dedication_title"] = dedicationTitle;
    if (dedicationMessage) props["_dedication_message"] = dedicationMessage;
    if (dedicationFrom) props["_dedication_from"] = dedicationFrom;
    if (finalPhotoMessage) props["_final_photo_message"] = finalPhotoMessage;
    // Family photo like the child photo: upload -> S3 key in _final_photo_url
    var uploadedFinalPhoto =
      card.getAttribute("data-bajka-uploaded-final-photo") || "";
    var ffInp = card.querySelector('[data-prop="Zdjęcie rodzinne"]');
    var ffFile = ffInp && ffInp.files && ffInp.files[0];
    if (uploadedFinalPhoto) {
      props["_final_photo_url"] = uploadedFinalPhoto;
    } else if (ffFile) {
      familyUploads.push(
        bajkaUploadFileRaw(ffFile).then(function (key) {
          if (!key) throw new Error("Family photo upload returned no key");
          if (!ffInp.files || ffInp.files[0] !== ffFile) {
            throw new Error("Family photo changed during upload");
          }
          props["_final_photo_url"] = key;
          card.setAttribute("data-bajka-uploaded-final-photo", key);
        }),
      );
    } else {
      var preservedPhoto = card.getAttribute(
        "data-bajka-preserved-final-photo",
      );
      if (preservedPhoto) props["_final_photo_url"] = preservedPhoto;
    }
    return { id: id, quantity: 1, properties: props };
  }

  function showCrossCardDiscount(card, pct) {
    var base = Number(card.getAttribute("data-price")) || 0;
    var discounted = Math.round(base * (1 - pct / 100));
    var newEl = card.querySelector("[data-cross-new]");
    var badgeEl = card.querySelector("[data-cross-badge]");
    if (newEl) {
      newEl.textContent = formatMoney(discounted);
      newEl.hidden = false;
    }
    if (badgeEl) {
      badgeEl.textContent = "−" + pct + " %";
      badgeEl.hidden = false;
    }
    return base - discounted;
  }

  function updateCrossPricing() {
    var selected = wizard.querySelectorAll(".bajka-cross.is-selected");
    var confirmLabel = wizard.querySelector("[data-bajka-cross-confirm-label]");
    if (confirmLabel) {
      confirmLabel.textContent = selected.length
        ? BAJKA_I18N.addSelectedBooks
        : BAJKA_I18N.goToCart;
    }
    var selectedCount = selected.length;
    var totalBooks = cartBajkaBookCount + selectedCount;
    // Highlight tiers based on total books (cart + pending cross selections)
    wizard.querySelectorAll(".bajka-cross-tier").forEach(function (tier) {
      var n = Number(tier.getAttribute("data-bajka-tier")) || 0;
      var minBooks = n + 1;
      tier.classList.toggle("is-active", totalBooks >= minBooks);
    });
    var savings = 0;
    selected.forEach(function (card, i) {
      var position = cartBajkaBookCount + i + 1;
      var pct = discountPctForBookPosition(position);
      savings += showCrossCardDiscount(card, pct);
    });
    var previewPosition = cartBajkaBookCount + selectedCount + 1;
    var previewPct = discountPctForBookPosition(previewPosition);
    wizard
      .querySelectorAll(".bajka-cross:not(.is-selected)")
      .forEach(function (card) {
        showCrossCardDiscount(card, previewPct);
      });
    // Update the "You save" tab
    var savingsValue = wizard.querySelector("[data-bajka-cross-savings-value]");
    if (savingsValue) savingsValue.textContent = formatMoney(savings);
  }

  function openCrossPopup() {
    if (bajkaIsMultiCharacter()) {
      finishCrossOffer();
      return;
    }
    var nameEl = wizard.querySelector("#bajka-name");
    var nameOut = wizard.querySelector("[data-bajka-cross-name]");
    if (nameOut)
      nameOut.textContent =
        (nameEl && nameEl.value.trim()) || BAJKA_I18N.yourHeroPossessive;

    // Insert the matching book set based on the selected gender
    var crossTarget = wizard.querySelector("[data-bajka-cross]");
    var gender = genderSelection();
    var tplId =
      gender === "Dziewczyna"
        ? "bajka-crosssell-maedchen"
        : "bajka-crosssell-junge";
    var crossTpl = document.getElementById(tplId);
    if (crossTarget && crossTpl) {
      crossTarget.innerHTML = crossTpl.innerHTML;
    }
    // Do not offer the current book as cross-sell (globally rendered -> exclude here)
    var curH = bajkaCurrentHandle || bajkaProductHandle();
    if (crossTarget && curH) {
      var selfCard = crossTarget.querySelector(
        '.bajka-cross[data-handle="' + curH + '"]',
      );
      if (selfCard && selfCard.parentNode)
        selfCard.parentNode.removeChild(selfCard);
    }

    if (crossPopup) crossPopup.hidden = false;
    refreshCartBajkaCounts().then(function () {
      applyCrossConfig();
      updateCrossPersonalizationControls();
    });
  }

  // Adapt cross-sell cards to the selected configuration (format + binding): price + tags
  function applyCrossConfig() {
    var fmt = "",
      fmtLabel = "";
    if (selectedCard) {
      var st = (selectedCard.getAttribute("data-title") || "")
        .toLowerCase()
        .replace(/×/g, "x")
        .replace(/\s/g, "");
      if (st.indexOf("21x21") > -1) {
        fmt = "21x21";
        fmtLabel = "21×21 cm";
      } else if (st.indexOf("30x30") > -1) {
        fmt = "30x30";
        fmtLabel = "30×30 cm";
      }
    }
    var bindingKey = "normal"; // Layflat-Option entfernt -> immer Normal-Bindung

    wizard.querySelectorAll(".bajka-cross").forEach(function (c) {
      var pAttr = fmt
        ? c.getAttribute("data-p-" + fmt + "-" + bindingKey)
        : null;
      var price = pAttr
        ? Number(pAttr)
        : Number(c.getAttribute("data-price")) || 0;
      c.setAttribute("data-price", price); // base for discount calculation
      var oldEl = c.querySelector(".bajka-cross__old");
      if (oldEl) oldEl.textContent = formatMoney(price);
      var tagsEl = c.querySelector("[data-cross-tags]");
      if (tagsEl) {
        tagsEl.innerHTML = fmtLabel
          ? '<span class="bajka-cross__tag">' + fmtLabel + "</span>"
          : "";
      }
    });
    updateCrossPricing();
  }
  function closeCrossPopup() {
    if (crossPopup) crossPopup.hidden = true;
  }

  function reopenCrossPopup() {
    if (!crossPopup) return;
    crossPopup.hidden = false;
    var confirmButton = crossPopup.querySelector("[data-bajka-cross-confirm]");
    if (confirmButton) confirmButton.focus();
  }

  var CART_URL =
    window.routes && window.routes.cart_url ? window.routes.cart_url : "/cart";

  // Section names needed by the cart drawer for rendering
  function cartSectionIds() {
    var cart = document.querySelector("cart-drawer");
    return cart && typeof cart.getSectionsToRender === "function"
      ? cart.getSectionsToRender().map(function (s) {
          return s.id;
        })
      : ["cart-drawer", "cart-icon-bubble"];
  }

  // Cart Drawer aus der Section-Antwort rendern (theme-eigene Methode)
  function renderFromState(state, openAfter) {
    var cart = document.querySelector("cart-drawer");
    if (!cart) return;
    // Prefers the theme's own renderContents (fills drawer + opens it)
    if (state && state.sections && typeof cart.renderContents === "function") {
      try {
        cart.renderContents(state);
        return;
      } catch (e) {
        console.error("[bajka] renderContents error:", e);
      }
    }
    // Fallback: manuell aus state.sections
    var sectionHtml = state && state.sections && state.sections["cart-drawer"];
    if (sectionHtml) {
      var doc = new DOMParser().parseFromString(sectionHtml, "text/html");
      var src = doc.querySelector("#CartDrawer");
      var cur = cart.querySelector("#CartDrawer");
      if (src && cur) cur.innerHTML = src.innerHTML;
      var sd = doc.querySelector("cart-drawer");
      if (sd)
        cart.classList.toggle("is-empty", sd.classList.contains("is-empty"));
      var bubbleHtml = state.sections["cart-icon-bubble"];
      if (bubbleHtml) {
        var bd = new DOMParser().parseFromString(bubbleHtml, "text/html");
        var bsrc =
          bd.querySelector("#cart-icon-bubble") ||
          bd.querySelector(".shopify-section");
        var bcur = document.getElementById("cart-icon-bubble");
        if (bsrc && bcur) bcur.innerHTML = bsrc.innerHTML;
      }
    }
    if (openAfter && typeof cart.open === "function") cart.open();
  }

  // Sort extras under their book AND wrap each group / each product in a bordered box
  function groupCartItems() {
    // Rendering is now server-side via snippets/bajka-cart-line.liquid.
  }

  // Ensure grouping persists: re-group whenever the cart content changes
  // (e.g. when the theme re-renders the cart drawer on open/update).
  // Reliably observes the whole document – even if the cart drawer appears later.
  (function observeCartGrouping() {
    if (!("MutationObserver" in window)) return;
    var scheduled = false;
    var root = document.documentElement;
    var obs = new MutationObserver(function (mutations) {
      // Only react when the change affects the cart
      var relevant = false;
      for (var m = 0; m < mutations.length; m++) {
        var t = mutations[m].target;
        if (
          t &&
          t.closest &&
          (t.closest("#CartDrawer") ||
            t.id === "CartDrawer" ||
            (t.querySelector && t.querySelector("#CartDrawer")))
        ) {
          relevant = true;
          break;
        }
      }
      if (!relevant) return;
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        if (!document.querySelector("#CartDrawer")) return;
        obs.disconnect();
        try {
          groupCartItems();
        } catch (e) {}
        obs.observe(root, { childList: true, subtree: true });
      });
    });
    function start() {
      obs.observe(root, { childList: true, subtree: true });
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", start);
    } else {
      start();
    }
  })();

  // Update the drawer without a visible reload:
  // fetch the current page (renders the cart drawer fully) and inject #CartDrawer.
  // Ordnet gespeicherte Vorschaubilder (localStorage, pro Gruppe) den Cart-Buttons zu.
  function bajkaApplyStoredPreviews() {
    if (
      window.BajkaCart &&
      typeof window.BajkaCart.applyStoredPreviews === "function"
    ) {
      window.BajkaCart.applyStoredPreviews();
    }
  }

  // Schneller Refresh: nur die Mini-Section (Drawer + Bubble) holen statt der ganzen Seite
  function refreshCart(openAfter) {
    var cart = document.querySelector("cart-drawer");
    if (!cart) {
      window.location.reload();
      return;
    }
    var sectionId = cart.getAttribute("data-section-id");
    if (!sectionId) {
      refreshCartFull(openAfter);
      return;
    }
    var miniCartId = "MiniCart-" + sectionId;
    Promise.all([
      fetch(
        "/?section_id=" + encodeURIComponent(sectionId) + "&_=" + Date.now(),
        { cache: "no-store" },
      ).then(function (r) {
        if (!r.ok) throw 0;
        return r.text();
      }),
      fetch("/?section_id=cart-icon-bubble&_=" + Date.now(), {
        cache: "no-store",
      })
        .then(function (r) {
          return r.ok ? r.text() : "";
        })
        .catch(function () {
          return "";
        }),
    ])
      .then(function (results) {
        var html = results[0];
        var bubbleHtml = results[1];
        var doc = new DOMParser().parseFromString(html, "text/html");
        var srcMini = doc.getElementById(miniCartId);
        var curMini = document.getElementById(miniCartId);
        if (srcMini && curMini) curMini.innerHTML = srcMini.innerHTML;
        var sd = doc.querySelector("cart-drawer");
        if (sd)
          cart.classList.toggle("is-empty", sd.classList.contains("is-empty"));
        if (bubbleHtml) {
          var bd = new DOMParser().parseFromString(bubbleHtml, "text/html");
          var bsrc =
            bd.querySelector("#cart-icon-bubble") ||
            bd.querySelector(".shopify-section");
          var bcur = document.getElementById("cart-icon-bubble");
          if (bsrc && bcur) bcur.innerHTML = bsrc.innerHTML;
        }
        groupCartItems();
        bajkaApplyStoredPreviews();
        setTimeout(groupCartItems, 350);
        setTimeout(groupCartItems, 900);
        if (openAfter && typeof cart.show === "function") cart.show();
      })
      .catch(function () {
        refreshCartFull(openAfter);
      });
  }

  // Fallback: kompletter Seiten-Fetch (wie bisher)
  function refreshCartFull(openAfter) {
    var cart = document.querySelector("cart-drawer");
    if (!cart) {
      window.location.reload();
      return;
    }
    fetch(window.location.pathname + "?_=" + Date.now(), { cache: "no-store" })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var sectionId = cart.getAttribute("data-section-id");
        var miniCartId = sectionId ? "MiniCart-" + sectionId : "";
        var srcMini = miniCartId ? doc.getElementById(miniCartId) : null;
        var curMini = miniCartId ? document.getElementById(miniCartId) : null;
        if (srcMini && curMini) curMini.innerHTML = srcMini.innerHTML;
        groupCartItems();
        bajkaApplyStoredPreviews();
        setTimeout(groupCartItems, 350);
        setTimeout(groupCartItems, 900);
        var sd = doc.querySelector("cart-drawer");
        if (sd)
          cart.classList.toggle("is-empty", sd.classList.contains("is-empty"));
        var bsrc = doc.querySelector("#cart-icon-bubble");
        var bcur = document.getElementById("cart-icon-bubble");
        if (bsrc && bcur) bcur.innerHTML = bsrc.innerHTML;
        if (openAfter && typeof cart.show === "function") cart.show();
      })
      .catch(function () {
        if (openAfter) window.location.reload();
      });
  }

  var addToCartPending = false;
  var crossOfferPrimaryAdded = false;
  var familyPhotoRetry = null;

  function clearFamilyPhotoUploadError() {
    familyPhotoRetry = null;
    wizard
      .querySelectorAll("[data-bajka-family-upload-error]")
      .forEach(function (el) {
        el.hidden = true;
      });
  }

  function showFamilyPhotoUploadError(includeCross, options) {
    clearFamilyPhotoUploadError();
    familyPhotoRetry = function () {
      addToCart(includeCross, options);
    };
    var selector = options.crossOnly
      ? "[data-bajka-cross-popup] [data-bajka-family-upload-error]"
      : '[data-step-panel="5"] [data-bajka-family-upload-error]';
    var errorBox = wizard.querySelector(selector);
    if (!errorBox) return;
    errorBox.hidden = false;
    errorBox.scrollIntoView({ behavior: "smooth", block: "center" });
    var retryButton = errorBox.querySelector(
      "[data-bajka-family-upload-retry]",
    );
    if (retryButton) retryButton.focus({ preventScroll: true });
  }

  wizard.addEventListener("click", function (event) {
    var retryButton = event.target.closest("[data-bajka-family-upload-retry]");
    if (retryButton && familyPhotoRetry) {
      familyPhotoRetry();
      return;
    }
    if (!event.target.closest("[data-bajka-family-upload-change]")) return;
    clearFamilyPhotoUploadError();
    closeCrossPopup();
    goToStep(4);
    var photoCard = selectedFinalPhotoExtraCard();
    var input =
      photoCard && photoCard.querySelector('[data-prop="Zdjęcie rodzinne"]');
    if (input) {
      input
        .closest(".bajka-upload")
        .scrollIntoView({ behavior: "smooth", block: "center" });
      input.focus({ preventScroll: true });
    }
  });

  function setAddToCartLoading(loading) {
    wizard
      .querySelectorAll("[data-bajka-family-upload-error]:not([hidden])")
      .forEach(function (el) {
        el.classList.toggle("is-loading", loading);
        el.setAttribute("aria-busy", loading ? "true" : "false");
        el.querySelectorAll("button").forEach(function (button) {
          button.disabled = loading;
        });
      });
    var overlay = wizard.querySelector("[data-bajka-cross-loading]");
    if (overlay) overlay.hidden = !loading;
    if (crossPopup) crossPopup.classList.toggle("is-loading", loading);
    wizard
      .querySelectorAll("[data-bajka-cross-confirm], [data-bajka-cross-skip]")
      .forEach(function (btn) {
        btn.disabled = loading;
        btn.setAttribute("aria-busy", loading ? "true" : "false");
      });
    if (checkoutBtn) {
      checkoutBtn.disabled = loading;
      checkoutBtn.setAttribute("aria-busy", loading ? "true" : "false");
    }
    var closeBtn = wizard.querySelector("[data-bajka-cross-close]");
    if (closeBtn) closeBtn.disabled = loading;
  }

  function resetAddToCartState() {
    addToCartPending = false;
    setAddToCartLoading(false);
  }

  function finishCrossOffer() {
    resetAddToCartState();
    crossOfferPrimaryAdded = false;
    closeCrossPopup();
    closeWizard();
    window.location.href = CART_URL;
  }

  function rememberUpsellPersonalizationNotice() {
    try {
      sessionStorage.setItem(BAJKA_UPSELL_NOTICE_KEY, "1");
    } catch (e) {}
  }

  function showPendingUpsellPersonalizationNotice() {
    var shouldShow = false;
    try {
      shouldShow = sessionStorage.getItem(BAJKA_UPSELL_NOTICE_KEY) === "1";
    } catch (e) {}
    if (
      !shouldShow ||
      document.querySelector("[data-bajka-upsell-personalization-notice]")
    )
      return;

    var beforeTarget =
      document.querySelector("main-cart .cart__form") ||
      document.querySelector("cart-drawer cart-items");
    var container =
      (beforeTarget && beforeTarget.parentNode) ||
      document.querySelector("#CartDrawer .drawer__scrollable") ||
      document.querySelector("main-cart") ||
      document.querySelector("cart-drawer");
    if (!container) return;

    var notice = document.createElement("div");
    notice.className = "bajka-cart-personalization-notice";
    notice.setAttribute("data-bajka-upsell-personalization-notice", "");
    notice.setAttribute("role", "status");
    notice.textContent = BAJKA_UPSELL_NOTICE_TEXT;
    if (beforeTarget && beforeTarget.parentNode) {
      beforeTarget.parentNode.insertBefore(notice, beforeTarget);
    } else {
      container.insertBefore(notice, container.firstChild);
    }
    try {
      sessionStorage.removeItem(BAJKA_UPSELL_NOTICE_KEY);
    } catch (e) {}
  }

  // Wrapper: ensures the child photo is uploaded (key for _photo_url),
  // before the items are built. Kicks in if the preview did not set the key.
  function addToCart(includeCross, options) {
    options = options || {};
    if (addToCartPending) return;
    if (!validateStep1BeforeCart()) return;
    if (bajkaIsMultiCharacter() && !bajkaHasCachedPreview()) {
      goToStep(2);
      bajkaGeneratePreview();
      return;
    }
    addToCartPending = true;
    setAddToCartLoading(true);
    var cp = wizard.querySelector("#bajka-photo");
    var cf = cp && cp.files && cp.files[0];
    // Original (uncropped) photos must be stored with the order too.
    var originalsReady = bajkaEnsureAllOriginalUploads().catch(function () {});
    var photoReady =
      !bajkaUploadedKey && cf
        ? bajkaUploadPhoto(cf).catch(function () {})
        : Promise.resolve();
    Promise.all([photoReady, originalsReady]).then(function () {
      addToCartRun(includeCross, options);
    });
  }

  function addToCartRun(includeCross, options) {
    options = options || {};
    var primaryOnly = options.primaryOnly === true;
    var crossOnly = options.crossOnly === true;
    var openCrossAfter = options.openCrossAfter === true;
    var items = [];
    var familyUploads = []; // Uploads des Familienfotos (Urkunde) -> vor dem Cart-Add abwarten
    var shouldShowUpsellPersonalizationNotice = false;
    // When editing: take the old group (for replacement) and consume it
    var oldKeys = crossOnly ? [] : editingOldGroupKeys.slice();
    // Unique group ID for THIS configuration (book + its extras)
    var groupId = newBajkaGroupId();
    var bookId = wizard.getAttribute("data-selected-variant");
    if (!crossOnly && bookId) {
      var bookProps = gatherProperties();
      bookProps["_bajka_group"] = groupId;
      bookProps["_group_id"] = groupId; // Backend-Key (parallel)
      // Generiertes Vorschaubild: versteckt als _preview mitsenden (+ lokal pro Gruppe merken).
      // If the (long/signed) URL breaks /cart/add, it automatically retries without _preview.
      appendPreviewToBookProps(bookProps, groupId);
      items.push({ id: bookId, quantity: 1, properties: bookProps });
    }
    // Extras (mark as compact in cart) – same group ID as the book
    if (!crossOnly) {
      wizard
        .querySelectorAll("[data-bajka-extras] .bajka-product.is-selected")
        .forEach(function (c) {
          var extraItem = buildExtraCartItem(c, groupId, familyUploads);
          if (extraItem) items.push(extraItem);
        });
    }
    // Cross-sell books -> same personalisation as the main book
    if (includeCross && !primaryOnly) {
      // Determine the same format + binding as the main book
      var fmt = "";
      if (selectedCard) {
        var st = (selectedCard.getAttribute("data-title") || "")
          .toLowerCase()
          .replace(/×/g, "x")
          .replace(/\s/g, "");
        if (st.indexOf("21x21") > -1) fmt = "21x21";
        else if (st.indexOf("30x30") > -1) fmt = "30x30";
      }
      var bindingKey =
        layflatToggle && layflatToggle.checked ? "layflat" : "normal";
      var selectedCrossCards = wizard.querySelectorAll(
        ".bajka-cross.is-selected",
      );
      var copiedAnyUpsellExtra = false;
      wizard.querySelectorAll(".bajka-cross.is-selected").forEach(function (c) {
        // passende Variante (gleiche Konfiguration), sonst Standard
        var matchId = fmt
          ? c.getAttribute("data-v-" + fmt + "-" + bindingKey)
          : null;
        var id = matchId || c.getAttribute("data-variant-id");
        if (!id) return;
        var crossGroupId = newBajkaGroupId();
        var crossProps = gatherProperties(c.getAttribute("data-theme"));
        crossProps["_bajka_group"] = crossGroupId;
        crossProps["_group_id"] = crossGroupId;
        appendPreviewToBookProps(crossProps, crossGroupId);
        items.push({ id: id, quantity: 1, properties: crossProps });

        if (crossCopyChecked(c, "dedication")) {
          var dedicationCard = selectedDedicationExtraCard();
          var dedicationItem =
            dedicationCard &&
            buildExtraCartItem(dedicationCard, crossGroupId, familyUploads);
          if (dedicationItem) {
            copiedAnyUpsellExtra = true;
            items.push(dedicationItem);
          }
        }

        if (crossCopyChecked(c, "final-photo")) {
          var finalPhotoCard = selectedFinalPhotoExtraCard();
          var finalPhotoItem =
            finalPhotoCard &&
            buildExtraCartItem(finalPhotoCard, crossGroupId, familyUploads);
          if (finalPhotoItem) {
            copiedAnyUpsellExtra = true;
            items.push(finalPhotoItem);
          }
        }
      });
      shouldShowUpsellPersonalizationNotice =
        selectedCrossCards.length > 0 && !copiedAnyUpsellExtra;
    }
    // Wait for family photo upload(s), then add to cart
    Promise.all(familyUploads)
      .then(function () {
        if (
          items.some(function (item) {
            return (
              item.properties &&
              item.properties._type === "final_photo" &&
              !item.properties._final_photo_url
            );
          })
        ) {
          throw new Error("Family photo has no uploaded key");
        }
        return true;
      })
      .catch(function (error) {
        resetAddToCartState();
        showFamilyPhotoUploadError(includeCross, options);
        if (window.console)
          console.warn("[bajka] Family photo upload failed:", error);
        return false;
      })
      .then(function (uploadReady) {
        if (!uploadReady) return;
        clearFamilyPhotoUploadError();
        if (!crossOnly) editingOldGroupKeys = [];
        // Remove items without a valid variant ID
        items = items.filter(function (it) {
          return it.id && String(it.id).trim() !== "";
        });

        if (!items.length) {
          resetAddToCartState();
          if (crossOnly) {
            finishCrossOffer();
            return;
          }
          if (openCrossAfter) {
            crossOfferPrimaryAdded = true;
            openCrossPopup();
            return;
          }
          closeCrossPopup();
          return;
        }

        // Add new items (happens AFTER removing the old ones when editing,
        // so the new book does not merge with the old row and keeps its group)
        function addNewItems(retryNoPreview) {
          // If needed, remove _preview (long URL) so /cart/add does not fail
          var payloadItems = items;
          if (retryNoPreview === true) {
            payloadItems = items.map(function (it) {
              if (it.properties && it.properties._preview) {
                var p = {};
                for (var k in it.properties) {
                  if (k !== "_preview") p[k] = it.properties[k];
                }
                return { id: it.id, quantity: it.quantity, properties: p };
              }
              return it;
            });
          }
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ items: payloadItems }),
          })
            .then(function (r) {
              return r.json().then(function (data) {
                return { ok: r.ok, status: r.status, data: data };
              });
            })
            .then(function (result) {
              if (!result.ok) {
                if (retryNoPreview !== true) {
                  addNewItems(true);
                  return;
                } // evtl. _preview zu lang
                resetAddToCartState();
                alert(
                  BAJKA_I18N.cartAddError +
                    "\n\n" +
                    ((result.data &&
                      (result.data.description || result.data.message)) ||
                      BAJKA_I18N.unknownError),
                );
                return;
              }
              if (openCrossAfter) {
                crossOfferPrimaryAdded = true;
                resetAddToCartState();
                openCrossPopup();
                return;
              }
              if (shouldShowUpsellPersonalizationNotice) {
                rememberUpsellPersonalizationNotice();
              }
              finishCrossOffer();
            })
            .catch(function () {
              if (retryNoPreview !== true) {
                addNewItems(true);
                return;
              } // non-JSON/error -> retry without _preview
              resetAddToCartState();
              window.location = CART_URL;
            });
        }

        // When editing: FIRST remove the old book + its extras, THEN add the new ones
        if (oldKeys.length) {
          var updates = {};
          oldKeys.forEach(function (k) {
            updates[k] = 0;
          });
          fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ updates: updates }),
          })
            .then(function () {
              addNewItems();
            })
            .catch(function () {
              addNewItems();
            });
        } else {
          addNewItems();
        }
      }); // Promise.all(familyUploads)
  }

  // Bajka cart remove and preview actions live in assets/bajka-cart.js.

  // "Dodaj do koszyka" adds the configured book first, then shows optional books.
  var checkoutBtn = wizard.querySelector("[data-bajka-checkout]");
  if (checkoutBtn)
    checkoutBtn.addEventListener("click", function () {
      if (crossOfferPrimaryAdded) {
        reopenCrossPopup();
        return;
      }
      addToCart(false, {
        primaryOnly: true,
        openCrossAfter: !bajkaIsMultiCharacter(),
      });
    });

  // Cross-sell card on/off
  wizard.addEventListener("click", function (e) {
    var cross = e.target.closest(".bajka-cross");
    if (cross && cross.closest("[data-bajka-cross]")) {
      if (
        e.target.closest(
          "[data-bajka-cross-personalization], [data-bajka-flip-open]",
        )
      )
        return;
      cross.classList.toggle("is-selected");
      updateCrossPricing();
      updateCrossPersonalizationControls();
    }
  });

  // Popup-Aktionen
  wizard.querySelectorAll("[data-bajka-cross-confirm]").forEach(function (b) {
    b.addEventListener("click", function () {
      addToCart(true, { crossOnly: crossOfferPrimaryAdded });
    });
  });
  wizard.querySelectorAll("[data-bajka-cross-skip]").forEach(function (b) {
    b.addEventListener("click", function () {
      if (crossOfferPrimaryAdded) {
        finishCrossOffer();
        return;
      }
      addToCart(false);
    });
  });
  wizard.querySelectorAll("[data-bajka-cross-close]").forEach(function (b) {
    b.addEventListener("click", function () {
      if (crossOfferPrimaryAdded) {
        finishCrossOffer();
        return;
      }
      closeCrossPopup();
    });
  });

  /* --- Cart edit: loads the variants of the correct book, then replaces the old group on save --- */
  function prefillCharacter(name, gender, age, hair, eyes) {
    var nameI = wizard.querySelector("#bajka-name");
    if (nameI) nameI.value = name || "";
    var ageI = wizard.querySelector("#bajka-age");
    if (ageI) ageI.value = age || "";
    gender = normalizeGenderSelection(gender);
    hair = normalizeHairSelection(hair);
    eyes = normalizeEyeSelection(eyes);
    [
      ["gender", gender],
      ["hair", hair],
      ["eyes", eyes],
    ].forEach(function (pair) {
      wizard
        .querySelectorAll('[data-field="' + pair[0] + '"] .bajka-option')
        .forEach(function (o) {
          o.classList.toggle(
            "is-selected",
            !!pair[1] && o.getAttribute("data-value") === pair[1],
          );
        });
    });
    updateHairTierPreviews();
    wizard
      .querySelectorAll('[data-step-panel="1"] .bajka-field')
      .forEach(function (f) {
        f.hidden = false;
      });
    restoreStep1PhotoPreview();
    var consent = wizard.querySelector("#bajka-consent");
    if (consent && bajkaHasPhoto()) consent.checked = true;
    checkStep1();
  }

  function normTitle(t) {
    return (t || "").toLowerCase().replace(/×/g, "x").replace(/[\s-]/g, "");
  }

  function displayDateToIso(val) {
    if (!val) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(val)) return val;
    var m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(val);
    if (m) return m[3] + "-" + m[2] + "-" + m[1];
    return val;
  }

  function resolvePhotoSrc(src) {
    if (!src) return "";
    if (/^(https?:|data:image\/|blob:|\/)/.test(src)) return src;
    var resolver = window.ChildbookPhoto && window.ChildbookPhoto.resolveUrl;
    if (typeof resolver !== "function") return "";
    try {
      return resolver(src) || "";
    } catch (e) {
      return "";
    }
  }

  function prefillExtrasFromCart(groupId) {
    if (!groupId) return;
    document
      .querySelectorAll(".bajka-cart-line--extra[data-variant-id]")
      .forEach(function (lineEl) {
        if (lineEl.getAttribute("data-bajka-group") !== groupId) return;
        var vid = lineEl.getAttribute("data-variant-id");
        if (!vid) return;
        var card = wizard.querySelector(
          '[data-bajka-extras] .bajka-product[data-variant-id="' + vid + '"]',
        );
        if (!card) return;

        card.classList.add("is-selected");
        var fields = card.querySelector(".bajka-extra-fields");
        if (fields) fields.hidden = false;

        var propMap = {
          "data-bajka-prop-dedication-title": "Tytuł dedykacji",
          "data-bajka-prop-dedication-message": "Wiadomość",
          "data-bajka-prop-dedykacja": "Wiadomość",
          "data-bajka-prop-dedication-from": "Podpis",
          "data-bajka-prop-naglowek": "Nagłówek",
        };
        Object.keys(propMap).forEach(function (attr) {
          var val = lineEl.getAttribute(attr);
          if (!val) return;
          var inp = card.querySelector('[data-prop="' + propMap[attr] + '"]');
          if (inp) inp.value = val;
        });

        var dedicationLayoutUrl =
          lineEl.getAttribute("data-bajka-prop-dedication-layout-url") || "";
        if (dedicationLayoutUrl) {
          card
            .querySelectorAll('[data-prop="_dedication_layout_url"]')
            .forEach(function (radio) {
              radio.checked = radio.value === dedicationLayoutUrl;
            });
        }

        var preservedPhoto = lineEl.getAttribute(
          "data-bajka-preserved-final-photo",
        );
        if (preservedPhoto) {
          card.setAttribute("data-bajka-preserved-final-photo", preservedPhoto);
          var previewImg = card.querySelector(".bajka-upload__preview");
          var placeholder = card.querySelector(".bajka-upload__placeholder");
          var resolved = resolvePhotoSrc(preservedPhoto);
          if (previewImg && resolved) {
            previewImg.src = resolved;
            previewImg.hidden = false;
            if (placeholder) placeholder.hidden = true;
          }
        }
      });
    checkStep4();
  }

  function buildFormatCard(
    title,
    desc,
    vNormal,
    vLayflat,
    fallbackImg,
    badge,
    imgOverride,
  ) {
    if (!vNormal) return "";
    // Priority as in normal flow: metafield format image > variant image > default image
    var img =
      imgOverride ||
      (vNormal.featured_image && vNormal.featured_image.src) ||
      fallbackImg ||
      "";
    var attrs =
      'data-title="' +
      esc(title) +
      '" data-variant-normal="' +
      vNormal.id +
      '" data-price-normal="' +
      vNormal.price +
      '"' +
      ' data-compare-normal="' +
      (vNormal.compare_at_price || "") +
      '"';
    if (vLayflat) {
      attrs +=
        ' data-variant-layflat="' +
        vLayflat.id +
        '" data-price-layflat="' +
        vLayflat.price +
        '" data-compare-layflat="' +
        (vLayflat.compare_at_price || "") +
        '"' +
        ' data-surcharge="' +
        esc(formatMoney(vLayflat.price - vNormal.price)) +
        '"';
    }
    return (
      '<div class="bajka-product" ' +
      attrs +
      ">" +
      (badge
        ? '<span class="bajka-product__badge">' + esc(badge) + "</span>"
        : "") +
      '<img class="bajka-product__image" src="' +
      esc(img) +
      '" alt="' +
      esc(title) +
      '" loading="lazy">' +
      '<div class="bajka-product__title">' +
      esc(title) +
      "</div>" +
      '<p class="bajka-product__desc">' +
      esc(desc) +
      "</p>" +
      '<div class="bajka-product__price">' +
      esc(formatMoney(vNormal.price)) +
      "</div>" +
      "</div>"
    );
  }

  // Step-3 cards for a book that has no rendered template on the current page,
  // rebuilt from the product JSON. Used by the cart edit and the email resume.
  function bajkaFormatCardsHtml(product, img21x21, img30x30) {
    var vars = product.variants || [];
    var sN, sL, lN, lL;
    vars.forEach(function (v) {
      var t = normTitle(v.title);
      if (t.indexOf("21x21") > -1) {
        if (t.indexOf("layflat") > -1) sL = v;
        else sN = v;
      } else if (t.indexOf("30x30") > -1) {
        if (t.indexOf("layflat") > -1) lL = v;
        else lN = v;
      }
    });
    if (!sN) sN = vars[0];
    if (!lN) lN = vars[vars.length - 1];
    var fb = product.featured_image || "";
    return (
      buildFormatCard(
        BAJKA_I18N.format21Title,
        BAJKA_I18N.format21Desc,
        sN,
        sL,
        fb,
        "",
        img21x21 || "",
      ) +
      buildFormatCard(
        BAJKA_I18N.format30Title,
        BAJKA_I18N.format30Desc,
        lN,
        lL,
        fb,
        BAJKA_I18N.mostChosen,
        img30x30 || "",
      )
    );
  }

  function savedPreviewImage(editBtn, oldGroup) {
    var previewImage = editBtn.getAttribute("data-bajka-preview") || "";
    if (!previewImage && oldGroup) {
      try {
        previewImage = localStorage.getItem("bajka_preview_" + oldGroup) || "";
      } catch (e) {}
    }
    return previewImage;
  }

  function applyEditPreservedMedia(editBtn, oldGroup) {
    var previewImage = savedPreviewImage(editBtn, oldGroup);
    var waited =
      editBtn.getAttribute("data-bajka-waited-for-preview") === "yes";
    if (bajkaIsMultiCharacter()) {
      bajkaHeldFallbackImage = previewImage;
      bajkaLoadCharacter(0);
      window.BajkaWizardPreview.adoptSaved({
        image: previewImage,
        runId: "",
        waited: waited,
      });
      return;
    }
    bajkaPreservedPhotoUrl = editBtn.getAttribute("data-bajka-photo-url") || "";
    bajkaPreservedPhotoName =
      editBtn.getAttribute("data-bajka-photo-name") || "";
    bajkaHeldFallbackImage = previewImage;
    // The cart line stores the image but not the render job, so the preview
    // cannot be re-sent by email until it is regenerated.
    if (bajkaPreservedPhotoUrl) {
      bajkaUploadedKey = bajkaPreservedPhotoUrl;
      bajkaUploadedFor = "preserved:" + bajkaPreservedPhotoUrl;
    }
    window.BajkaWizardPreview.adoptSaved({
      image: previewImage,
      runId: "",
      waited: waited,
    });
    restoreStep1PhotoPreview();
    var consent = wizard.querySelector("#bajka-consent");
    if (consent && bajkaHasPhoto()) consent.checked = true;
    checkStep1();
  }

  function openEditWizard(editBtn) {
    bajkaIsCartEditMode = true;
    var editMode = editBtn.getAttribute("data-bajka-edit-mode") || "full";
    var targetStep = editMode === "book" ? 3 : 5;
    // Cart edits replace the whole grouped book configuration on save.
    var cartItem = editBtn.closest(".cart-item");
    var oldGroup =
      editBtn.getAttribute("data-bajka-group") ||
      (cartItem && cartItem.getAttribute("data-bajka-group"));
    var editLineKey = editBtn.getAttribute("data-line-key");
    editingOldGroupKeys = [];
    function rememberOldKey(key) {
      if (key && editingOldGroupKeys.indexOf(key) === -1)
        editingOldGroupKeys.push(key);
    }
    if (oldGroup) {
      // whole group (book + extras)
      document
        .querySelectorAll(".cart-item[data-bajka-group]")
        .forEach(function (itemEl) {
          if (itemEl.getAttribute("data-bajka-group") !== oldGroup) return;
          itemEl.querySelectorAll(".bajka-remove-btn").forEach(function (b) {
            rememberOldKey(b.getAttribute("data-line-key"));
          });
        });
    }
    if (!editingOldGroupKeys.length && editLineKey) {
      // If the grouped wrapper is not present in the current render, still replace the clicked cart line.
      rememberOldKey(editLineKey);
    } else if (!editingOldGroupKeys.length && cartItem) {
      // no group -> replace at least this one item
      var rb = cartItem.querySelector(".bajka-remove-btn");
      rememberOldKey(rb && rb.getAttribute("data-line-key"));
    }

    var serializedCharacters =
      editBtn.getAttribute("data-bajka-characters") || "";
    var serializedConfig =
      editBtn.getAttribute("data-bajka-character-config") || "";
    bajkaSetCharacterConfig(
      serializedCharacters && !serializedConfig ? "{}" : serializedConfig,
    );
    if (serializedCharacters && !bajkaCharacterConfigInvalid) {
      try {
        var restoredCharacters = JSON.parse(serializedCharacters);
        bajkaCharacters = bajkaCharacterConfig.slots.map(
          function (slot, index) {
            var restored =
              restoredCharacters.find(function (candidate) {
                return candidate && candidate.slotKey === slot.key;
              }) ||
              restoredCharacters[index] ||
              {};
            var state = bajkaCreateCharacterState(slot);
            state.name = restored.name || "";
            state.gender = normalizeGenderSelection(restored.gender || "");
            state.age = restored.age || "";
            state.hair = normalizeHairSelection(restored.hair || "");
            state.eyes = normalizeEyeSelection(restored.eyes || "");
            state.photoUrl = restored.photoKey || "";
            state.photoName = restored.photoName || BAJKA_I18N.photo;
            state.uploadedKey = restored.photoKey || null;
            state.uploadedFor = restored.photoKey
              ? "preserved:" + restored.photoKey
              : null;
            state.consent = !!restored.photoKey;
            return state;
          },
        );
        bajkaCharacterIndex = 0;
        bajkaLoadCharacter(0);
      } catch (error) {
        bajkaSetCharacterConfig("{}");
      }
    } else if (!serializedCharacters) {
      bajkaCharacters = bajkaCharacterConfig.slots.map(
        bajkaCreateCharacterState,
      );
      bajkaCharacterIndex = 0;
      bajkaLoadCharacter(0);
      prefillCharacter(
        editBtn.getAttribute("data-bajka-name"),
        editBtn.getAttribute("data-bajka-gender"),
        editBtn.getAttribute("data-bajka-age"),
        editBtn.getAttribute("data-bajka-hair"),
        editBtn.getAttribute("data-bajka-eyes"),
      );
    }
    if (bajkaCharacterConfigInvalid) targetStep = 1;
    var cd = document.querySelector("cart-drawer");
    if (cd && typeof cd.close === "function") cd.close();

    var handle = editBtn.getAttribute("data-bajka-handle");
    bajkaCurrentHandle = handle || "";
    bajkaCurrentTheme = editBtn.getAttribute("data-bajka-theme") || "";
    bajkaSetBookLanguage(
      editBtn.getAttribute("data-bajka-language") || BAJKA_BOOK_LANGUAGE,
    );
    if (!handle) {
      openWizard(document.querySelector("[data-bajka-wizard-open]"));
      applyEditPreservedMedia(editBtn, oldGroup);
      prefillExtrasFromCart(oldGroup);
      goToStep(targetStep);
      return;
    }

    fetch("/products/" + handle + ".js", {
      headers: { Accept: "application/json" },
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (product) {
        var fb = product.featured_image || "";
        if (fb) bajkaDefaultBookImage = fb; // Standard-Produktbild merken
        var html = bajkaFormatCardsHtml(
          product,
          editBtn.getAttribute("data-bajka-img-21x21") || "",
          editBtn.getAttribute("data-bajka-img-30x30") || "",
        );

        openWizard(); // opens + injects default templates ...
        applyEditPreservedMedia(editBtn, oldGroup);
        var target = wizard.querySelector("[data-bajka-products]");
        if (target) target.innerHTML = html; // ... which we overwrite with the CORRECT book
        if (themeTitleEl && product.title)
          themeTitleEl.textContent = product.title;

        // Pre-select the previously chosen variant (format + binding)
        var vTitle = (editBtn.getAttribute("data-bajka-variant") || "")
          .toLowerCase()
          .replace(/×/g, "x")
          .replace(/\s/g, "");
        var wantLayflat = vTitle.indexOf("layflat") > -1;
        var wantFmt =
          vTitle.indexOf("30x30") > -1
            ? "30x30"
            : vTitle.indexOf("21x21") > -1
              ? "21x21"
              : "";
        var match = null;
        if (target && wantFmt) {
          target.querySelectorAll(".bajka-product").forEach(function (card) {
            var ct = (card.getAttribute("data-title") || "")
              .toLowerCase()
              .replace(/×/g, "x")
              .replace(/\s/g, "");
            if (ct.indexOf(wantFmt) > -1) match = card;
          });
        }
        // Fallback: no format match -> select first card so the book
        // always gets a valid variant ID + group on save
        if (!match && target) {
          match = target.querySelector(".bajka-product");
        }
        if (match) {
          selectCard(match); // marks + shows upsell, resets layflat
          if (
            layflatToggle &&
            wantLayflat &&
            match.getAttribute("data-variant-layflat")
          ) {
            layflatToggle.checked = true;
            updateSelectedVariant();
            updateLayflatVisual();
          }
        }

        prefillExtrasFromCart(oldGroup);
        goToStep(targetStep);
      })
      .catch(function () {
        window.location = editBtn.getAttribute("data-bajka-url") || "/";
      });
  }

  document.addEventListener("click", function (e) {
    var editBtn = e.target.closest("[data-bajka-edit-open]");
    if (!editBtn) return;
    e.preventDefault();
    openEditWizard(editBtn);
  });

  /* --- Resume from the preview email (?bajka_resume=<token>) --- */

  // The token resolves to a child's photo and first name, so it is removed from
  // the address bar before anything else can read it: no referrer leakage to
  // third-party assets, nothing to copy out of the URL, nothing left in history.
  function bajkaTakeResumeToken() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return "";
    }
    var token = (params.get(BAJKA_RESUME_PARAM) || "").trim();
    if (!token) return "";
    params.delete(BAJKA_RESUME_PARAM);
    if (window.history && typeof window.history.replaceState === "function") {
      var query = params.toString();
      try {
        window.history.replaceState(
          null,
          "",
          window.location.pathname +
            (query ? "?" + query : "") +
            window.location.hash,
        );
      } catch (e) {}
    }
    return token;
  }

  function bajkaFetchResume(token) {
    return fetch(PREVIEW_RESUME_ENDPOINT + encodeURIComponent(token), {
      headers: { Accept: "application/json" },
    }).then(function (response) {
      if (!response.ok) {
        return response
          .json()
          .catch(function () {
            return null;
          })
          .then(function (data) {
            throw new Error(
              "resume rejected: " +
                ((data && data.errorCode) || response.status),
            );
          });
      }
      return response.json();
    });
  }

  // Same restore path as a cart edit, with two differences: the run id survives,
  // so the visitor can mail the preview to themselves again, and the photo key is
  // known, so step 1 shows the actual photo instead of the generated image.
  function bajkaApplyResume(payload) {
    var character = (payload && payload.character) || {};
    if (character.productHandle) bajkaCurrentHandle = character.productHandle;
    if (character.productTheme) bajkaCurrentTheme = character.productTheme;
    if (
      payload &&
      payload.version === 2 &&
      Array.isArray(payload.characters) &&
      bajkaIsMultiCharacter()
    ) {
      bajkaCharacters = bajkaCharacterConfig.slots.map(function (slot, index) {
        var restored =
          payload.characters.find(function (candidate) {
            return candidate && candidate.slotKey === slot.key;
          }) ||
          payload.characters[index] ||
          {};
        var state = bajkaCreateCharacterState(slot);
        state.name = restored.name || "";
        state.gender = normalizeGenderSelection(restored.gender || "");
        state.age = restored.age || "";
        state.hair = normalizeHairSelection(restored.hair || "");
        state.eyes = normalizeEyeSelection(restored.eyes || "");
        state.photoUrl = restored.photoKey || "";
        state.photoName = restored.photoName || BAJKA_I18N.photo;
        state.uploadedKey = restored.photoKey || null;
        state.uploadedFor = restored.photoKey
          ? "preserved:" + restored.photoKey
          : null;
        state.consent = !!restored.photoKey;
        return state;
      });
      bajkaCharacterIndex = 0;
      bajkaLoadCharacter(0);
      window.BajkaWizardPreview.adoptSaved({
        image: payload.imageUrl || "",
        runId: payload.runId || "",
      });
      bajkaHeldFallbackImage = window.BajkaWizardPreview.lastImage();
      goToStep(2);
      return;
    }
    bajkaPreservedPhotoUrl = character.photoKey || "";
    bajkaPreservedPhotoName = BAJKA_I18N.photo;
    if (bajkaPreservedPhotoUrl) {
      bajkaUploadedKey = bajkaPreservedPhotoUrl;
      bajkaUploadedFor = "preserved:" + bajkaPreservedPhotoUrl;
    }
    prefillCharacter(
      character.name,
      character.gender,
      character.age,
      character.hair,
      character.eyes,
    );
    // Claiming the current inputs as already rendered is what makes step 2 show
    // this image instead of spending another render job on the same character.
    window.BajkaWizardPreview.adoptSaved({
      image: payload.imageUrl || "",
      runId: payload.runId || "",
    });
    goToStep(2);
  }

  // The link lands on the book's own product page, where the step-3 cards come
  // from that page's template. If it does not, rebuild them from product JSON.
  function bajkaOpenResumeWithoutTrigger(handle, payload) {
    if (!handle) {
      openWizard();
      bajkaApplyResume(payload);
      return Promise.resolve();
    }
    return fetch("/products/" + encodeURIComponent(handle) + ".js", {
      headers: { Accept: "application/json" },
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (product) {
        var fb = product.featured_image || "";
        if (fb) bajkaDefaultBookImage = fb;
        var html = bajkaFormatCardsHtml(product, "", "");
        openWizard();
        bajkaApplyResume(payload);
        var target = wizard.querySelector("[data-bajka-products]");
        if (target && html) target.innerHTML = html;
        if (themeTitleEl && product.title)
          themeTitleEl.textContent = product.title;
      });
  }

  function bajkaTriggerForHandle(handle) {
    if (!handle) return null;
    var match = null;
    document
      .querySelectorAll("[data-bajka-wizard-open][data-product-handle]")
      .forEach(function (el) {
        if (!match && el.getAttribute("data-product-handle") === handle)
          match = el;
      });
    return match;
  }

  // Failure is silent by design: an expired or unknown token leaves the visitor
  // on a normal product page rather than facing an error about a link they were
  // sent days ago.
  function bajkaResumeFromEmailLink() {
    var token = bajkaTakeResumeToken();
    if (!token) return;
    bajkaFetchResume(token)
      .then(function (payload) {
        var handle =
          (payload && payload.character && payload.character.productHandle) ||
          "";
        var trigger = bajkaTriggerForHandle(handle);
        if (trigger) {
          openWizard(trigger);
          bajkaApplyResume(payload);
          return null;
        }
        return bajkaOpenResumeWithoutTrigger(handle, payload);
      })
      .catch(function (err) {
        if (window.console) {
          try {
            console.warn(
              "[bajka] Preview resume failed:",
              err && err.message ? err.message : err,
            );
          } catch (e) {}
        }
      });
  }

  /* --- Preview popup behavior is handled by assets/bajka-cart.js --- */

  // Remove extra (dedication/certificate) from the order summary
  document.addEventListener("click", function (e) {
    var rm = e.target.closest("[data-bajka-remove-extra]");
    if (!rm) return;
    e.preventDefault();
    var vid = rm.getAttribute("data-bajka-remove-extra");
    var card = wizard.querySelector(
      '[data-bajka-extras] .bajka-product[data-variant-id="' + vid + '"]',
    );
    if (card) {
      card.classList.remove("is-selected");
      card.removeAttribute("data-bajka-preserved-final-photo");
      var fields = card.querySelector(".bajka-extra-fields");
      if (fields) fields.hidden = true;
    }
    buildSummary(); // rebuild summary
  });

  window.BajkaWizardPreview.attach({
    wizard: wizard,
    i18n: BAJKA_I18N,
    bookLanguage: BAJKA_BOOK_LANGUAGE,
    shopDomain: BAJKA_SHOP_DOMAIN,
    isMultiCharacter: bajkaIsMultiCharacter,
    captureCurrentCharacter: bajkaCaptureCurrentCharacter,
    selectedOption: bajkaSelectedOption,
    ageValue: bajkaAgeValue,
    normalizeGender: normalizeGenderSelection,
    eyeColorMap: EYE_COLOR_MAP,
    genderMap: GENDER_MAP,
    uploadPhoto: bajkaUploadPhoto,
    uploadFileRaw: bajkaUploadFileRaw,
    productHandle: bajkaProductHandle,
    dedicationGenderKey: dedicationGenderKey,
    live: {
      get characters() {
        return bajkaCharacters;
      },
      get characterConfig() {
        return bajkaCharacterConfig;
      },
      get currentHandle() {
        return bajkaCurrentHandle;
      },
      get currentTheme() {
        return bajkaCurrentTheme;
      },
      get productTitle() {
        return (themeTitleEl && themeTitleEl.textContent.trim()) || "";
      },
      get uploadedKey() {
        return bajkaUploadedKey;
      },
      get uploadedFor() {
        return bajkaUploadedFor;
      },
      get preservedPhotoUrl() {
        return bajkaPreservedPhotoUrl;
      },
    },
  });

  // Group existing cart items on load
  groupCartItems();
  bajkaApplyStoredPreviews();
  // Resume waits for the deferred character-preview.js, which owns the resolver
  // that turns a stored photo key back into a displayable URL.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      showPendingUpsellPersonalizationNotice();
      bajkaResumeFromEmailLink();
    });
  } else {
    showPendingUpsellPersonalizationNotice();
    bajkaResumeFromEmailLink();
  }
})();
